import React, { Component } from 'react'
import clsx from 'clsx'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import PropTypes from 'prop-types'
import {
  CssBaseline, CircularProgress, Container, Button, Grid, Typography,
  Tabs, Tab, Card, CardContent, Chip, Divider, IconButton, Tooltip,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,
  Dialog, DialogTitle, DialogContent, DialogActions, Pagination, LinearProgress,
  Checkbox, FormControlLabel, Stepper, Step, StepLabel, TextField
} from '@mui/material'
import { withStyles } from '@mui/styles'
import { Styles } from '../../styles/material-styles'
import { Overlay } from '../../styles/global'
import CustomizedSnackbars from '../../components/material-snackbars'
import HeaderMenu from '../../components/header-menu'
import Footer from '../../components/footer'
import { injectIntl } from 'react-intl'
import Api from '../../services/api'
import * as componentActions from '../../redux/actions/organizations'

// Icons
import CreditCardIcon from '@mui/icons-material/CreditCard'
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong'
import ReceiptIcon from '@mui/icons-material/Receipt'
import HistoryIcon from '@mui/icons-material/History'
import PaymentIcon from '@mui/icons-material/Payment'
import CancelIcon from '@mui/icons-material/Cancel'
import SwapHorizIcon from '@mui/icons-material/SwapHoriz'
import UpgradeIcon from '@mui/icons-material/Upgrade'
import DeleteIcon from '@mui/icons-material/Delete'
import StarIcon from '@mui/icons-material/Star'
import StarBorderIcon from '@mui/icons-material/StarBorder'
import AddIcon from '@mui/icons-material/Add'
import RemoveIcon from '@mui/icons-material/Remove'
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import RefreshIcon from '@mui/icons-material/Refresh'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import ErrorIcon from '@mui/icons-material/Error'
import WarningIcon from '@mui/icons-material/Warning'
import InfoIcon from '@mui/icons-material/Info'
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart'
import EventIcon from '@mui/icons-material/Event'
import InventoryIcon from '@mui/icons-material/Inventory'
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart'
import RestoreIcon from '@mui/icons-material/Restore'
import CompareArrowsIcon from '@mui/icons-material/CompareArrows'
import PeopleIcon from '@mui/icons-material/People'
import StorageIcon from '@mui/icons-material/Storage'
import SupportAgentIcon from '@mui/icons-material/SupportAgent'

// Services
import { getSubscriptionStatus, cancelSubscription, createCheckoutSession, getAvailablePlans, getContractProducts, getAvailableProducts, addProductToContract, getPlanPeriodicities, changePlan, reactivateSubscription, getPlanChangePreview, getSubscriptionUsage, getPlanFeatures, cancelProducts, getCanceledProducts, getCreditBalances, purchaseCredits, updateCreditSettings, getCreditPaymentMethods, subscribe, getProvisioningStatus } from '../../services/subscription.service'
import {
  getPaymentMethods, createSetupIntent, setDefaultPaymentMethod,
  deletePaymentMethod, getInvoices, getUpcomingInvoice, retryInvoicePayment,
  getBillingHistory
} from '../../services/billing.service'
// getContract removed — hirerId comes from userSession

// Stripe
import StripeCardFormDialog from '../../components/stripe-card-form'

const PAGE_SIZE_INVOICES = 10
const PAGE_SIZE_HISTORY = 20

class SubscriptionManagement extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loading: false,
      tabValue: 0,
      openNotification: false,
      notificationVariant: 'error',
      notificationMessage: '',

      // Overview
      subscription: null,
      contractPlan: null,
      hirerId: 0,

      // Invoices
      invoices: [],
      invoicesTotalCount: 0,
      invoicesPage: 1,
      upcomingInvoice: null,
      loadingUpcoming: false,

      // Payment Methods
      paymentMethods: [],
      loadingPaymentMethods: false,
      addCardDialogOpen: false,
      clientSecret: null,
      deleteDialogOpen: false,
      deleteTarget: null,

      // History
      events: [],
      historyTotalCount: 0,
      historyPage: 1,

      // Cancel dialog
      cancelDialogOpen: false,
      canceling: false,

      // Checkout
      checkoutLoading: false,

      // Plan selection wizard (Assinar Agora)
      planSelectDialogOpen: false,
      availablePlans: [],
      selectedPlanPeriodicityId: 0,
      loadingPlans: false,
      subscribeStep: 0,
      subscribeProducts: [],
      subscribeProductsLoading: false,
      subscribeSelectedProductIds: [],
      subscribeProductSelections: {},
      subscribeAvailablePlans: {},
      subscribeAvailablePeriodicities: {},
      subscribeConfirmOpen: false,
      subscribePaymentMethods: [],
      subscribePaymentMethodsLoading: false,
      subscribeSelectedPaymentMethodId: null,
      subscribeAddCardOpen: false,
      subscribeAddCardSecret: null,

      // Products tab
      contractProducts: [],
      loadingProducts: false,

      // Credits
      creditBalances: [],
      usageFilterPlanPeriodicityId: null,
      creditDialogOpen: false,
      creditDialogBalance: null,
      creditDialogProduct: null,
      creditPurchaseAmount: '',
      creditPurchaseLoading: false,
      creditSettingsLoading: false,
      creditEditCreditAmountMonthly: '',
      creditEditAlertThreshold: '',
      creditEditAutoRechargeEnabled: false,
      creditEditAutoRechargeAmount: '',
      creditEditAutoRechargeTrigger: '',
      creditPurchaseConfirmOpen: false,
      creditPaymentMethods: [],
      creditSelectedPaymentMethodId: '',

      // Usage & Features
      usageData: [],
      planFeatures: [],
      loadingUsage: false,

      // Change plan wizard
      changePlanDialogOpen: false,
      changePlanStep: 0, // 0=select product, 1=select plan+periodicity, 2=confirm, 3=processing
      changePlanSelectedProduct: null,
      changePlanAllPeriodicities: [],
      changePlanPlans: [],
      changePlanSelectedPlanId: 0,
      changePlanPeriodicities: [],
      changePlanSelectedNewId: 0,
      changePlanLoading: false,

      // Cancel products dialog
      cancelProductsDialogOpen: false,
      cancelProductsStep: 0,
      cancelProductsSelected: [],
      cancelProductsLoading: false,

      // Reactivate dialog
      reactivateDialogOpen: false,
      reactivateSelected: [],
      reactivateLoading: false,
      reactivateCanceledProducts: [],
      reactivateStep: 0,
    }

    this.closeNotification = this.closeNotification.bind(this)
  }

  async componentDidMount() {
    // Check if navigated with a default tab
    const locationState = this.props.location && this.props.location.state
    if (locationState && locationState.defaultTab != null) {
      this.setState({ tabValue: locationState.defaultTab })
    }

    // Check checkout return status from URL
    const params = new URLSearchParams(this.props.location.search)
    const checkoutStatus = params.get('checkout')
    if (checkoutStatus === 'success') {
      this.showSuccess(this.props.intl.formatMessage({ id: 'subscription.checkout.success' }))
      // Clean URL
      this.props.history.replace(this.props.location.pathname)
    } else if (checkoutStatus === 'cancel') {
      this.showInfo(this.props.intl.formatMessage({ id: 'subscription.checkout.canceled' }))
      this.props.history.replace(this.props.location.pathname)
    }

    const hirerId = this.props.userSession && this.props.userSession.user
      ? this.props.userSession.user.hirerid
      : 0

    if (hirerId) {
      await new Promise(resolve => this.setState({ hirerId, loading: true }, resolve))
      try {
        await this.loadSubscriptionStatus()
        await Promise.all([
          this.loadPaymentMethods(),
          this.loadUsageAndFeatures(),
          this.loadContractProducts()
        ])
      } catch (err) {
        console.error('Error loading subscription:', err)
      }
      this.setState({ loading: false })
    }
  }

  async loadSubscriptionStatus() {
    const { hirerId } = this.state
    if (!hirerId) return

    try {
      const result = await getSubscriptionStatus(hirerId)
      console.log('[SubscriptionManagement] loadSubscriptionStatus hirerId:', hirerId, 'result:', result?.data)
      if (result && result.data && result.data.data) {
        this.setState({ subscription: result.data.data })
      } else if (result && result.data && result.data.success === true && !result.data.data) {
        console.warn('[SubscriptionManagement] API returned success but no data for hirerId:', hirerId)
      }
    } catch (err) {
      console.error('Error loading subscription:', err)
    }
  }

  async loadUsageAndFeatures() {
    const { hirerId } = this.state
    if (!hirerId) return

    this.setState({ loadingUsage: true })
    try {
      const [usageResult, featuresResult] = await Promise.all([
        getSubscriptionUsage(hirerId),
        getPlanFeatures(hirerId)
      ])

      if (usageResult && usageResult.data && usageResult.data.data) {
        const data = usageResult.data.data
        this.setState({ usageData: Array.isArray(data) ? data : [] })
      }

      if (featuresResult && featuresResult.data && featuresResult.data.data) {
        const data = featuresResult.data.data
        this.setState({ planFeatures: Array.isArray(data) ? data : [] })
      }
    } catch (err) {
      console.error('Error loading usage/features:', err)
    }
    this.setState({ loadingUsage: false })
  }

  async loadPaymentMethods() {
    const { hirerId } = this.state
    if (!hirerId) return

    this.setState({ loadingPaymentMethods: true })
    try {
      const result = await getPaymentMethods(hirerId)
      if (result && result.data && result.data.data) {
        const methods = Array.isArray(result.data.data) ? result.data.data : []
        this.setState({ paymentMethods: methods })
      }
    } catch (err) {
      console.error('Error loading payment methods:', err)
    }
    this.setState({ loadingPaymentMethods: false })
  }

  async loadInvoices() {
    const { hirerId, invoicesPage } = this.state
    if (!hirerId) return

    this.setState({ loading: true })
    try {
      const offset = (invoicesPage - 1) * PAGE_SIZE_INVOICES
      const result = await getInvoices(hirerId, PAGE_SIZE_INVOICES, offset)
      if (result && result.data && result.data.data) {
        const data = result.data.data
        const invoiceList = Array.isArray(data) ? data : (data.invoices || [])
        const total = data.totalcount || data.totalCount || invoiceList.length
        this.setState({ invoices: invoiceList, invoicesTotalCount: total })
      }
    } catch (err) {
      console.error('Error loading invoices:', err)
    }
    this.setState({ loading: false })
  }

  async loadUpcomingInvoice() {
    const { hirerId } = this.state
    if (!hirerId) return

    this.setState({ loadingUpcoming: true })
    try {
      const result = await getUpcomingInvoice(hirerId)
      if (result && result.data && result.data.data) {
        this.setState({ upcomingInvoice: result.data.data.invoice || result.data.data })
      } else {
        this.setState({ upcomingInvoice: null })
        this.showInfo(this.props.intl.formatMessage({ id: 'subscription.no.upcoming.invoice' }))
      }
    } catch (err) {
      this.setState({ upcomingInvoice: null })
    }
    this.setState({ loadingUpcoming: false })
  }

  async loadHistory() {
    const { hirerId, historyPage } = this.state
    if (!hirerId) return

    this.setState({ loading: true })
    try {
      const offset = (historyPage - 1) * PAGE_SIZE_HISTORY
      const result = await getBillingHistory(hirerId, PAGE_SIZE_HISTORY, offset)
      if (result && result.data && result.data.data) {
        const data = result.data.data
        const eventList = Array.isArray(data) ? data : (data.events || [])
        const total = data.totalcount || data.totalCount || eventList.length
        this.setState({ events: eventList, historyTotalCount: total })
      }
    } catch (err) {
      console.error('Error loading history:', err)
    }
    this.setState({ loading: false })
  }

  async loadContractProducts() {
    const { hirerId } = this.state
    if (!hirerId) return

    this.setState({ loadingProducts: true })
    try {
      const [productsResult, creditsResult] = await Promise.all([
        getContractProducts(hirerId),
        getCreditBalances(hirerId)
      ])
      if (productsResult && productsResult.data && productsResult.data.data) {
        const data = productsResult.data.data
        this.setState({ contractProducts: Array.isArray(data) ? data : [] })
      }
      if (creditsResult && creditsResult.data && creditsResult.data.data) {
        const data = creditsResult.data.data
        this.setState({ creditBalances: Array.isArray(data) ? data : [] })
      }
    } catch (err) {
      console.error('Error loading contract products:', err)
    }
    this.setState({ loadingProducts: false })
  }

  handleTabChange = (event, newValue) => {
    this.setState({ tabValue: newValue }, () => {
      if (newValue === 0) {
        this.loadSubscriptionStatus()
        this.loadUsageAndFeatures()
      } else if (newValue === 1) {
        this.loadContractProducts()
      } else if (newValue === 2) {
        this.loadPaymentMethods()
      } else if (newValue === 3) {
        this.loadInvoices()
      } else if (newValue === 4) {
        this.loadHistory()
      }
    })
  }

  // ── Overview Actions ──

  handleOpenPlanSelection = async () => {
    // Carregar produtos disponíveis e pré-selecionar os do contrato
    const currentProductIds = (this.state.contractProducts || []).map(p => p.applicationid ?? p.applicationId)
    this.setState({
      planSelectDialogOpen: true, subscribeStep: 0,
      subscribeSelectedProductIds: currentProductIds,
      subscribeProductSelections: {},
      subscribeAvailablePlans: {}, subscribeAvailablePeriodicities: {},
      subscribeProducts: [], subscribeProductsLoading: true, subscribeConfirmOpen: false,
    })
    const result = await getAvailableProducts()
    if (result && result.data && result.data.data) {
      this.setState({ subscribeProducts: result.data.data || [], subscribeProductsLoading: false })
    } else {
      this.setState({ subscribeProductsLoading: false })
    }
  }

  handleSubscribeToggleProduct = (id) => {
    this.setState(prev => {
      const s = [...prev.subscribeSelectedProductIds]
      const i = s.indexOf(id)
      if (i > -1) {
        s.splice(i, 1)
        const sel = { ...prev.subscribeProductSelections }
        delete sel[id]
        return { subscribeSelectedProductIds: s, subscribeProductSelections: sel }
      }
      // Ao adicionar produto: pre-popula quantity do trial atual quando houver.
      // Se o cliente ja tinha 6 agentes neste produto no trial, o stepper abre em 6.
      // Pra produtos novos (sem entry em contractProducts), default 1.
      s.push(id)
      const existingTrial = (prev.contractProducts || []).find(p => (p.applicationid ?? p.applicationId) === id)
      const trialQty = Number(existingTrial?.quantity ?? existingTrial?.Quantity) || 1
      const sel2 = { ...prev.subscribeProductSelections }
      if (!sel2[id]) sel2[id] = {}
      sel2[id] = { ...sel2[id], quantity: sel2[id].quantity || trialQty }
      return { subscribeSelectedProductIds: s, subscribeProductSelections: sel2 }
    })
  }

  handleSubscribeLoadPlans = async () => {
    this.setState({ loadingPlans: true })
    const result = await getAvailablePlans()
    if (result && result.data && result.data.data) {
      const allPPs = result.data.data || []
      const plansByApp = {}
      this.state.subscribeSelectedProductIds.forEach(appId => {
        const planMap = {}
        allPPs.filter(pp => (pp.applicationid ?? pp.applicationId) === appId && (pp.planid ?? pp.planId) !== 1)
          .forEach(pp => {
            const key = pp.planid ?? pp.planId
            if (!planMap[key]) planMap[key] = { id: key, name: pp.planname ?? pp.planName, isShared: pp.isshared ?? pp.isShared }
          })
        plansByApp[appId] = Object.values(planMap)
      })
      this.setState({ subscribeAvailablePlans: plansByApp, loadingPlans: false })
    } else {
      this.setState({ loadingPlans: false })
    }
  }

  handleSubscribeSelectPlan = (appId, plan) => {
    this.setState(prev => {
      const sel = { ...prev.subscribeProductSelections }
      sel[appId] = { planId: plan.id, planName: plan.name, isShared: plan.isShared, ppId: null, ppName: null, value: null }
      return { subscribeProductSelections: sel }
    })
  }

  handleSubscribeLoadPeriodicities = async () => {
    this.setState({ loadingPlans: true })
    const result = await getAvailablePlans()
    if (result && result.data && result.data.data) {
      const allPPs = result.data.data || []
      const perByApp = {}
      this.state.subscribeSelectedProductIds.forEach(appId => {
        const sel = this.state.subscribeProductSelections[appId]
        if (!sel) return
        perByApp[appId] = allPPs.filter(pp =>
          (pp.applicationid ?? pp.applicationId) === appId &&
          (pp.planid ?? pp.planId) === sel.planId
        )
      })
      this.setState({ subscribeAvailablePeriodicities: perByApp, loadingPlans: false })
    } else {
      this.setState({ loadingPlans: false })
    }
  }

  handleSubscribeSelectPeriodicity = (appId, pp) => {
    this.setState(prev => {
      const sel = { ...prev.subscribeProductSelections }
      const monthly = Number(pp.planvaluepermonth ?? pp.planValuePerMonth ?? pp.value ?? 0)
      const duration = Number(pp.durationmonths ?? pp.durationMonths ?? 1)
      // planValue: preco por unidade NO PERIODO. Cascata defensiva: planvalue da API > calculado via duration > monthly.
      // Defensive contra state stale ou response sem o campo.
      const planValueFromApi = Number(pp.planvalue ?? pp.planValue ?? 0)
      const planValue = planValueFromApi > 0 ? planValueFromApi : (monthly * duration)
      sel[appId] = {
        ...sel[appId],
        ppId: pp.id,
        ppName: pp.periodicityname ?? pp.periodicityName,
        // value: preco mensal (pra exibicao "X/mes" e MRR). planValue: preco do periodo (mensal/trim/anual) por unidade.
        value: monthly,
        planValue: planValue,
        durationMonths: duration,
        userLimit: pp.userlimit ?? pp.userLimit ?? null,
      }
      return { subscribeProductSelections: sel }
    })
  }

  // Stepper de quantidade. Usado no passo 3 (Periodicidade). Bloqueia abaixo de 1 e respeita
  // user_limit do plano (com override hardcoded 99 — quando MAX_QTY_OVERRIDE for null, usa o do plano).
  handleQuantityChange = (appId, delta) => {
    const MAX_QTY_OVERRIDE = 99;
    this.setState(prev => {
      const sel = { ...prev.subscribeProductSelections }
      const cur = sel[appId] || {}
      const planLimit = cur.userLimit && cur.userLimit > 0 ? cur.userLimit : 99
      const maxQty = MAX_QTY_OVERRIDE ?? planLimit
      const next = Math.max(1, Math.min(maxQty, (Number(cur.quantity) || 1) + delta))
      sel[appId] = { ...cur, quantity: next }
      return { subscribeProductSelections: sel }
    })
  }

  handleSubscribeLoadPaymentMethods = async () => {
    this.setState({ subscribePaymentMethodsLoading: true })
    const result = await getPaymentMethods(this.state.hirerId)
    if (result && result.data && result.data.data) {
      const methods = result.data.data.paymentmethods || result.data.data.paymentMethods || result.data.data || []
      this.setState({ subscribePaymentMethods: methods, subscribePaymentMethodsLoading: false,
        subscribeSelectedPaymentMethodId: methods.length > 0 ? (methods.find(m => m.isdefault || m.isDefault)?.gatewaypaymentmethodid || methods.find(m => m.isdefault || m.isDefault)?.gatewayPaymentMethodId || methods[0].gatewaypaymentmethodid || methods[0].gatewayPaymentMethodId || methods[0].id) : null })
    } else {
      this.setState({ subscribePaymentMethods: [], subscribePaymentMethodsLoading: false })
    }
  }

  handleSubscribeAddCard = async () => {
    const result = await createSetupIntent(this.state.hirerId)
    if (result && result.data && result.data.data) {
      const secret = result.data.data.clientsecret || result.data.data.clientSecret
      this.setState({ subscribeAddCardOpen: true, subscribeAddCardSecret: secret })
    }
  }

  handleSubscribeCardAdded = async () => {
    this.setState({ subscribeAddCardOpen: false, subscribeAddCardSecret: null })
    await this.handleSubscribeLoadPaymentMethods()
  }

  handleSubscribeNext = () => {
    const { subscribeStep, subscription } = this.state
    const gwType = subscription?.paymentgatewaytype ?? subscription?.paymentGatewayType ?? ''
    const isManual = gwType === 'manual'
    if (subscribeStep === 0) this.handleSubscribeLoadPlans()
    if (subscribeStep === 1) this.handleSubscribeLoadPeriodicities()
    if (subscribeStep === 2 && !isManual) this.handleSubscribeLoadPaymentMethods()
    this.setState(prev => ({ subscribeStep: prev.subscribeStep + 1 }))
  }

  handleSubscribeConfirm = async () => {
    const { hirerId, subscribeProductSelections, subscribeSelectedPaymentMethodId } = this.state

    // NAO fecha o modal principal — modal vira tela de progresso ate o pipeline
    // (Stripe sub + InsertContractStep via outbox) terminar via polling.
    // loading=true ativa Overlay padrao do sistema (linha 3420) — mantem UX consistente
    // com outras operacoes da tela.
    this.setState({
      subscribeConfirmOpen: false,
      checkoutLoading: true,
      loading: true,
      subscribeProvisioningPhase: 'submitting',
      subscribeProvisioningMessage: 'Processando sua assinatura...',
    })

    const products = Object.entries(subscribeProductSelections).map(([appId, sel]) => ({
      applicationId: parseInt(appId),
      planPeriodicityId: sel.ppId,
      quantity: Number(sel.quantity) || 1,
    }))

    const result = await subscribe(hirerId, products, subscribeSelectedPaymentMethodId)
    const data = result && result.data
    const success = data && data.success
    const payload = data && data.data

    if (!success) {
      const errorMsg = data && data.errors ? data.errors[0] : 'Erro ao processar assinatura'
      this.setState({ checkoutLoading: false, loading: false, subscribeProvisioningPhase: null, subscribeProvisioningMessage: null })
      this.showError(errorMsg)
      return
    }

    // Sucesso na criacao da Stripe sub. Agora aguarda InsertContractStep via outbox.
    const queueId = payload && (payload.provisioningqueueid ?? payload.provisioningQueueId)
    if (!queueId) {
      // Sem queueId: o backend nao chegou a publicar evento (caso de fluxo antigo
      // ou erro silencioso). Trata como sucesso direto pra nao bloquear o cliente.
      this.showSuccess('Assinatura realizada com sucesso!')
      this.setState({ checkoutLoading: false, loading: false, subscribeProvisioningPhase: null, subscribeProvisioningMessage: null })
      setTimeout(() => { localStorage.clear(); document.location.href = '/' }, 2500)
      return
    }

    this.startSubscribeProvisioningPolling(queueId)
  }

  // Polling do status da queue ate "completed" ou "failed" (ou 30 tentativas = 60s).
  // Atualiza subscribeProvisioningMessage conforme avanca pra dar feedback visual.
  startSubscribeProvisioningPolling = (queueId) => {
    let attempts = 0
    const maxAttempts = 60 // 60 × 2s = 120s timeout total

    const poll = async () => {
      attempts++
      try {
        const res = await getProvisioningStatus(queueId)
        const ok = res && res.data && res.data.success
        const status = ok && res.data.data
        if (status) {
          const s = (status.status || '').toLowerCase()
          if (s === 'completed') {
            this.showSuccess('Assinatura ativada com sucesso! Voce sera redirecionado.')
            this.setState({ checkoutLoading: false, loading: false, subscribeProvisioningPhase: 'done', subscribeProvisioningMessage: 'Concluido!', planSelectDialogOpen: false })
            setTimeout(() => { localStorage.clear(); document.location.href = '/' }, 2000)
            return
          }
          if (s === 'failed' || s === 'error') {
            this.showError(status.errormessage || status.errorMessage || 'Falha ao ativar assinatura. Contate o suporte.')
            this.setState({ checkoutLoading: false, loading: false, subscribeProvisioningPhase: null, subscribeProvisioningMessage: null })
            return
          }
          // Em processing: atualiza mensagem com step atual
          const step = status.currentstep ?? status.currentStep ?? 0
          const total = status.totalsteps ?? status.totalSteps ?? 1
          this.setState({
            subscribeProvisioningPhase: 'processing',
            subscribeProvisioningMessage: total > 1 ? `Ativando assinatura... (${step}/${total})` : 'Ativando assinatura...'
          })
        }
      } catch (err) {
        // Erro pontual de rede — continua tentando ate maxAttempts
        console.warn('polling status err', err)
      }

      if (attempts >= maxAttempts) {
        this.showError('A ativacao esta demorando mais que o esperado. Verifique o status da sua assinatura em alguns minutos.')
        this.setState({ checkoutLoading: false, loading: false, subscribeProvisioningPhase: null, subscribeProvisioningMessage: null })
        return
      }

      setTimeout(poll, 2000)
    }

    setTimeout(poll, 1500) // primeira tentativa apos 1.5s
  }

  handleCancelSubscription = async () => {
    const { hirerId } = this.state
    const intl = this.props.intl

    this.setState({ canceling: true })

    const result = await cancelSubscription(hirerId, true)

    if (result && result.data && result.data.success !== false) {
      this.setState({ cancelDialogOpen: false, canceling: false })
      this.showSuccess(intl.formatMessage({ id: 'subscription.cancel.success' }))
      await this.loadSubscriptionStatus()
    } else {
      this.setState({ canceling: false })
      this.showError(result.data && result.data.errors ? result.data.errors[0] : intl.formatMessage({ id: 'subscription.cancel.error' }))
    }
  }

  // ── Payment Methods Actions ──

  handleAddCard = async () => {
    const { hirerId } = this.state
    const intl = this.props.intl

    this.setState({ loading: true })
    const result = await createSetupIntent(hirerId)

    if (result && result.data && result.data.data) {
      const secret = result.data.data.clientsecret || result.data.data.clientSecret
      if (secret) {
        this.setState({ clientSecret: secret, addCardDialogOpen: true, loading: false })
        return
      }
    }

    this.setState({ loading: false })
    this.showError(intl.formatMessage({ id: 'billing.setup.intent.error' }))
  }

  handleCardAdded = () => {
    this.setState({ addCardDialogOpen: false, clientSecret: null })
    this.showSuccess(this.props.intl.formatMessage({ id: 'billing.card.added.success' }))
    setTimeout(() => this.loadPaymentMethods(), 2000)
  }

  handleSetDefault = async (paymentMethodId) => {
    const { hirerId } = this.state
    const intl = this.props.intl
    this.setState({ loading: true })

    const result = await setDefaultPaymentMethod(hirerId, paymentMethodId)
    if (result && result.data && result.data.success !== false) {
      this.showSuccess(intl.formatMessage({ id: 'billing.default.updated' }))
      await this.loadPaymentMethods()
    } else {
      this.showError(result.data && result.data.errors ? result.data.errors[0] : null)
    }
    this.setState({ loading: false })
  }

  handleDeleteConfirm = async () => {
    const { hirerId, deleteTarget } = this.state
    const intl = this.props.intl
    this.setState({ deleteDialogOpen: false, loading: true })

    const result = await deletePaymentMethod(hirerId, deleteTarget)
    if (result && result.data && result.data.success !== false) {
      this.showSuccess(intl.formatMessage({ id: 'billing.card.removed' }))
      await this.loadPaymentMethods()
    } else {
      this.showError(result.data && result.data.errors ? result.data.errors[0] : null)
    }
    this.setState({ loading: false })
  }

  // ── Invoice Actions ──

  handleRetryPayment = async (invoiceId) => {
    const intl = this.props.intl
    this.setState({ loading: true })

    const result = await retryInvoicePayment(invoiceId)
    if (result && result.data && result.data.success !== false) {
      this.showSuccess(intl.formatMessage({ id: 'billing.retry.success' }))
      await this.loadInvoices()
    } else {
      this.showError(result.data && result.data.errors ? result.data.errors[0] : null)
    }
    this.setState({ loading: false })
  }

  // ── Change Plan Wizard ──

  handleOpenChangePlan = () => {
    this.setState({ changePlanDialogOpen: true, changePlanStep: 0, changePlanSelectedProduct: null, changePlanAvailablePlans: [], changePlanSelectedNewId: 0 })
  }

  handleChangePlanSelectProduct = async (product) => {
    const appId = product.applicationid ?? product.applicationId ?? 0
    this.setState({ changePlanSelectedProduct: product, changePlanLoading: true })
    const result = await getPlanPeriodicities(appId)
    if (result && result.data && result.data.data) {
      const allPp = Array.isArray(result.data.data) ? result.data.data : []
      const currentPpId = product.planperiodicityid ?? product.planPeriodicityId ?? 0
      // Deduplicate by id and exclude current
      const seen = new Set()
      const filtered = allPp.filter(p => {
        const ppId = p.id || p.Id
        if (ppId === currentPpId || seen.has(ppId)) return false
        seen.add(ppId)
        return true
      })
      // Agrupar por plano
      const planMap = {}
      filtered.forEach(pp => {
        const pId = pp.planid ?? pp.planId ?? pp.plan_id ?? 0
        const pName = pp.planname ?? pp.planName ?? pp.PlanName ?? '-'
        if (!planMap[pId]) planMap[pId] = { id: pId, name: pName, periodicities: [] }
        planMap[pId].periodicities.push(pp)
      })
      this.setState({
        changePlanAllPeriodicities: filtered,
        changePlanPlans: Object.values(planMap),
        changePlanStep: 1,
        changePlanLoading: false,
        changePlanSelectedPlanId: 0,
        changePlanPeriodicities: [],
        changePlanSelectedNewId: 0
      })
    } else {
      this.setState({ changePlanLoading: false })
      this.showError('Erro ao carregar planos disponíveis')
    }
  }

  handleChangePlanSelectPlan = async (plan) => {
    const appId = this.state.changePlanSelectedProduct?.applicationid ?? this.state.changePlanSelectedProduct?.applicationId ?? 0
    this.setState({ changePlanSelectedPlanId: plan.id, changePlanPeriodicities: [], changePlanSelectedNewId: 0, changePlanLoading: true })
    const result = await getPlanPeriodicities(appId, plan.id)
    if (result && result.data && result.data.data) {
      const currentPpId = this.state.changePlanSelectedProduct?.planperiodicityid ?? this.state.changePlanSelectedProduct?.planPeriodicityId ?? 0
      const periodicities = (Array.isArray(result.data.data) ? result.data.data : []).filter(p => (p.id || p.Id) !== currentPpId)
      this.setState({ changePlanPeriodicities: periodicities, changePlanLoading: false })
    } else {
      this.setState({ changePlanPeriodicities: plan.periodicities, changePlanLoading: false })
    }
  }

  handleChangePlanSelectPeriodicity = (planPeriodicityId) => {
    this.setState({ changePlanSelectedNewId: planPeriodicityId, changePlanStep: 2 })
  }

  handleConfirmChangePlan = async () => {
    const { hirerId, changePlanSelectedProduct, changePlanSelectedNewId } = this.state
    const intl = this.props.intl
    const oldPpId = changePlanSelectedProduct.planperiodicityid ?? changePlanSelectedProduct.planPeriodicityId ?? 0
    this.setState({ changePlanLoading: true })
    const result = await changePlan(hirerId, oldPpId, changePlanSelectedNewId)
    if (result && result.data && result.data.success !== false) {
      this.setState({ changePlanDialogOpen: false, changePlanLoading: false })
      this.showSuccess(intl.formatMessage({ id: 'subscription.change.plan.success' }))
      await this.loadSubscriptionStatus()
      await this.loadContractProducts()
    } else {
      this.setState({ changePlanLoading: false })
      this.showError(result.data && result.data.errors ? result.data.errors[0] : 'Erro ao trocar plano')
    }
  }

  // ── Cancel Products ──

  handleOpenCancelProducts = () => {
    this.setState({ cancelProductsDialogOpen: true, cancelProductsStep: 0, cancelProductsSelected: [] })
  }

  handleToggleCancelProduct = (ppId) => {
    this.setState(prev => ({
      cancelProductsSelected: prev.cancelProductsSelected.includes(ppId)
        ? prev.cancelProductsSelected.filter(id => id !== ppId)
        : [...prev.cancelProductsSelected, ppId]
    }))
  }

  handleConfirmCancelProducts = async () => {
    const { hirerId, cancelProductsSelected } = this.state
    const intl = this.props.intl
    if (cancelProductsSelected.length === 0) return
    this.setState({ cancelProductsLoading: true })
    const result = await cancelProducts(hirerId, cancelProductsSelected)
    if (result && result.data && result.data.success !== false) {
      this.setState({ cancelProductsDialogOpen: false, cancelProductsLoading: false })
      this.showSuccess(intl.formatMessage({ id: 'subscription.cancel.products.success' }))
      await this.loadSubscriptionStatus()
      await this.loadContractProducts()
    } else {
      this.setState({ cancelProductsLoading: false })
      this.showError(result.data && result.data.errors ? result.data.errors[0] : 'Erro ao cancelar produtos')
    }
  }

  // ── Credit Actions ──

  handleOpenCreditDialog = async (balance) => {
    // Buscar dados de configuração do contract_plan_periodicity
    const cppId = balance.contractplanperiodicityid ?? balance.contractPlanPeriodicityId ?? 0
    const product = this.state.contractProducts.find(p => (p.id ?? p.Id) === cppId)

    this.setState({
      creditDialogOpen: true,
      creditDialogBalance: balance,
      creditDialogProduct: product,
      creditPurchaseAmount: '',
      creditPaymentMethods: [],
      creditSelectedPaymentMethodId: '',
      creditEditCreditAmountMonthly: product?.creditamountmonthly ?? product?.creditAmountMonthly ?? '',
      creditEditAlertThreshold: product?.creditalertthreshold ?? product?.creditAlertThreshold ?? '',
      creditEditAutoRechargeEnabled: product?.creditautorechargeenabled ?? product?.creditAutoRechargeEnabled ?? false,
      creditEditAutoRechargeAmount: product?.creditautorechargeamount ?? product?.creditAutoRechargeAmount ?? '',
      creditEditAutoRechargeTrigger: product?.creditautorechargetrigger ?? product?.creditAutoRechargeTrigger ?? '',
    })

    // Carregar formas de pagamento
    const pmResult = await getCreditPaymentMethods(cppId)
    if (pmResult && pmResult.data && pmResult.data.success !== false) {
      const methods = pmResult.data.data || []
      this.setState({
        creditPaymentMethods: methods,
        creditSelectedPaymentMethodId: methods.length === 1 ? String(methods[0].id) : ''
      })
    }
  }

  handlePurchaseCredits = async () => {
    const { hirerId, creditDialogBalance, creditPurchaseAmount, creditSelectedPaymentMethodId } = this.state
    const intl = this.props.intl
    this.setState({ creditPurchaseConfirmOpen: false })
    const amount = parseFloat(creditPurchaseAmount)
    if (!amount || amount <= 0) return

    const cppId = creditDialogBalance.contractplanperiodicityid ?? creditDialogBalance.contractPlanPeriodicityId
    const paymentMethodId = creditSelectedPaymentMethodId ? parseInt(creditSelectedPaymentMethodId) : null
    this.setState({ creditPurchaseLoading: true })
    const result = await purchaseCredits(hirerId, cppId, amount, paymentMethodId)
    if (result && result.data && result.data.success !== false) {
      this.showSuccess(intl.formatMessage({ id: 'subscription.credit.purchase.success' }))
      this.setState({ creditPurchaseLoading: false, creditPurchaseAmount: '' })
      await this.loadContractProducts()
    } else {
      this.setState({ creditPurchaseLoading: false })
      this.showError(result.data && result.data.errors ? result.data.errors[0] : 'Erro ao comprar créditos')
    }
  }

  handleSaveCreditSettings = async () => {
    const { hirerId, creditDialogBalance } = this.state
    const intl = this.props.intl
    const cppId = creditDialogBalance.contractplanperiodicityid ?? creditDialogBalance.contractPlanPeriodicityId
    this.setState({ creditSettingsLoading: true })
    const result = await updateCreditSettings(
      hirerId, cppId,
      this.state.creditEditAlertThreshold !== '' ? parseFloat(this.state.creditEditAlertThreshold) : null,
      this.state.creditEditAutoRechargeEnabled,
      this.state.creditEditAutoRechargeAmount !== '' ? parseFloat(this.state.creditEditAutoRechargeAmount) : null,
      this.state.creditEditAutoRechargeTrigger !== '' ? parseFloat(this.state.creditEditAutoRechargeTrigger) : null
    )
    if (result && result.data && result.data.success !== false) {
      this.showSuccess(intl.formatMessage({ id: 'subscription.credit.settings.success' }))
      this.setState({ creditSettingsLoading: false })
      await this.loadContractProducts()
    } else {
      this.setState({ creditSettingsLoading: false })
      this.showError(result.data && result.data.errors ? result.data.errors[0] : 'Erro')
    }
  }

  // ── Reactivate Actions ──

  handleOpenReactivate = async () => {
    const { hirerId } = this.state
    this.setState({ reactivateLoading: true })
    const result = await getCanceledProducts(hirerId)
    if (result && result.data && result.data.data) {
      const products = Array.isArray(result.data.data) ? result.data.data : []
      this.setState({ reactivateCanceledProducts: products, reactivateDialogOpen: true, reactivateLoading: false, reactivateSelected: [], reactivateStep: 0 })
    } else {
      this.setState({ reactivateLoading: false })
      this.showError('Nenhum produto cancelado encontrado')
    }
  }

  handleToggleReactivateProduct = (ppId) => {
    this.setState(prev => ({
      reactivateSelected: prev.reactivateSelected.includes(ppId)
        ? prev.reactivateSelected.filter(id => id !== ppId)
        : [...prev.reactivateSelected, ppId]
    }))
  }

  handleConfirmReactivate = async () => {
    const { hirerId, reactivateSelected } = this.state
    const intl = this.props.intl
    if (reactivateSelected.length === 0) return
    this.setState({ reactivateLoading: true })
    const result = await reactivateSubscription(hirerId, reactivateSelected)
    if (result && result.data && result.data.success !== false) {
      this.setState({ reactivateDialogOpen: false, reactivateLoading: false })
      this.showSuccess(intl.formatMessage({ id: 'subscription.reactivate.success' }))
      await this.loadSubscriptionStatus()
      await this.loadContractProducts()
    } else {
      this.setState({ reactivateLoading: false })
      this.showError(result.data && result.data.errors ? result.data.errors[0] : 'Erro ao reativar assinatura')
    }
  }

  // ── Notifications ──

  showSuccess(msg) {
    this.setState({ openNotification: true, notificationVariant: 'success', notificationMessage: msg })
  }

  showError(msg) {
    this.setState({ openNotification: true, notificationVariant: 'error', notificationMessage: msg || 'Erro' })
  }

  showInfo(msg) {
    this.setState({ openNotification: true, notificationVariant: 'info', notificationMessage: msg })
  }

  closeNotification() {
    this.setState({ openNotification: false })
  }

  // ── Formatting Helpers ──

  formatDate(dateStr) {
    if (!dateStr || dateStr === '0001-01-01T00:00:00') return '-'
    const d = new Date(dateStr)
    return d.toLocaleDateString('pt-BR')
  }

  formatDateTime(dateStr) {
    if (!dateStr || dateStr === '0001-01-01T00:00:00') return '-'
    const d = new Date(dateStr)
    return d.toLocaleDateString('pt-BR') + ' ' + d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })
  }

  formatCurrency(value, currency) {
    if (value == null) return '-'
    const cur = currency || 'BRL'
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: cur }).format(value)
  }

  getStatusColor(status) {
    const colors = {
      'paid': '#4caf50', 'open': '#ff9800', 'draft': '#2196f3',
      'void': '#9e9e9e', 'uncollectible': '#f44336',
      'active': '#4caf50', 'trialing': '#2196f3', 'past_due': '#ff9800',
      'canceled': '#f44336', 'unpaid': '#f44336', 'paused': '#9e9e9e'
    }
    return colors[status] || '#757575'
  }

  getContractStatusColor(statusId) {
    const id = parseInt(statusId) || 0
    const colors = {
      1: '#9e9e9e',   // Solicitado
      2: '#4caf50',   // Vigente
      3: '#f44336',   // Cancelado
      4: '#f44336',   // Cancelado
      5: '#2196f3',   // Em Trial
      6: '#f44336',   // Suspenso
      7: '#ff5722',   // Expirado
      8: '#ff9800'    // Aguardando Pagamento
    }
    return colors[id] || '#757575'
  }

  // ── RENDER: Overview Tab ──

  renderOverviewTab() {
    const { subscription, contractPlan, paymentMethods, loading } = this.state
    const intl = this.props.intl

    if (!subscription) {
      return (
        <div style={{ textAlign: 'center', padding: 60 }}>
          <InfoIcon style={{ fontSize: 56, color: '#bdbdbd', marginBottom: 8 }} />
          <Typography variant="h6" style={{ fontWeight: 600, color: '#616161' }}>
            {intl.formatMessage({ id: 'subscription.no.data' })}
          </Typography>
          <Typography variant="body2" color="textSecondary">
            {intl.formatMessage({ id: 'subscription.no.data.description' })}
          </Typography>
        </div>
      )
    }

    const sub = subscription || {}
    const planName = sub.planname || sub.planName || null
    const periodicityName = sub.periodicityname || sub.periodicityName || ''
    const statusId = parseInt(sub.contractstatusid ?? sub.contractStatusId ?? 0) || 0
    const statusName = sub.contractstatusname || sub.contractStatusName || (statusId === 5 ? 'Em Trial' : '-')
    const subscriptionStatus = sub.subscriptionstatus || sub.subscriptionStatus || (statusId === 5 ? 'trialing' : '')
    const price = sub.planprice || sub.planPrice
    const currency = sub.currency || 'BRL'
    const periodEnd = sub.currentperiodend || sub.currentPeriodEnd
    const trialEnd = sub.trialenddate || sub.trialEndDate
    const cancelAtPeriodEnd = sub.cancelatperiodend || sub.cancelAtPeriodEnd
    const isTrial = statusId === 5
    const isActive = statusId === 2
    const isCanceled = statusId === 3 || statusId === 4
    const isSuspended = statusId === 6
    const isExpired = statusId === 7
    const isPending = statusId === 1 || statusId === 8
    const hasSubscription = !!(sub.gatewaysubscriptionid || sub.gatewaySubscriptionId)
    const hasPlan = !!(planName && (sub.planid || sub.planId) > 0)

    // Plan features from contractPlan
    const cpp = contractPlan || {}
    const planPeriodicity = cpp.planperiodicity || cpp.planPeriodicity || {}
    const plan = planPeriodicity.plan || {}
    const features = plan.planfeatures || plan.planFeatures || []

    return (
      <Grid container spacing={3} style={{ marginTop: 8 }}>
        {/* Contract Card */}
        <Grid item xs={12} md={8}>
          <Card elevation={2}>
            <CardContent>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 16 }}>
                <div>
                  <Typography variant="overline" color="textSecondary">
                    {intl.formatMessage({ id: 'subscription.current.contract' })}
                  </Typography>
                  <Typography variant="h5" style={{ fontWeight: 700, color: '#212121' }}>
                    {intl.formatMessage({ id: 'subscription.contract.number' })} #{sub.contractid || sub.contractId || '-'}
                  </Typography>
                </div>
                <Chip
                  label={statusName}
                  sx={{
                    backgroundColor: this.getContractStatusColor(statusId) + ' !important',
                    color: '#fff !important',
                    fontWeight: 600,
                    fontSize: 13
                  }}
                />
              </div>

              {/* Pending / No Plan banner */}
              {isPending && !hasPlan && (
                <div style={{
                  padding: '16px 20px', backgroundColor: '#fff8e1',
                  border: '1px solid #ffe082', borderRadius: 8, marginBottom: 16
                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <WarningIcon style={{ color: '#f9a825' }} />
                    <div>
                      <Typography variant="subtitle2" style={{ fontWeight: 600, color: '#e65100' }}>
                        {intl.formatMessage({ id: 'subscription.pending.title' })}
                      </Typography>
                      <Typography variant="body2" color="textSecondary">
                        {intl.formatMessage({ id: 'subscription.pending.description' })}
                      </Typography>
                    </div>
                  </div>
                </div>
              )}

              <Divider style={{ marginBottom: 16 }} />

              {/* Contract Summary */}
              <Grid container spacing={2}>
                <Grid item xs={6} sm={3}>
                  <Typography variant="caption" color="textSecondary">
                    {intl.formatMessage({ id: 'subscription.total.value' })}
                  </Typography>
                  <Typography variant="h6" style={{ fontWeight: 600 }}>
                    {(() => {
                      // Total geral do contrato no periodo de cobranca = SOMA de
                      // (plan_value × quantity) de cada produto.
                      // - plan_value = preco por unidade NO PERIODO (mensal=ppm; trimestral=ppm*3; anual=ppm*12)
                      // - Itens com plan_value=0 (cortesia, ex.: 2TALK hoje) nao somam
                      // - Fallback pra plan_value_per_month quando plan_value nao vier (queues legadas)
                      const products = this.state.contractProducts || []
                      const total = products.reduce((sum, p) => {
                        const monthly = p.planvaluepermonth ?? p.planValuePerMonth ?? 0
                        const qty = p.quantity ?? p.Quantity ?? 1
                        const contractedValue = p.planvalue ?? p.planValue ?? monthly
                        return sum + (contractedValue * qty)
                      }, 0)
                      return total > 0 ? this.formatCurrency(total, currency) : this.formatCurrency(price, currency)
                    })()}
                  </Typography>
                </Grid>
                {periodEnd && (
                  <Grid item xs={6} sm={3}>
                    <Typography variant="caption" color="textSecondary">
                      {intl.formatMessage({ id: 'subscription.next.billing' })}
                    </Typography>
                    <Typography variant="body1" style={{ fontWeight: 500 }}>
                      {this.formatDate(periodEnd)}
                    </Typography>
                  </Grid>
                )}
                {trialEnd && isTrial && (
                  <Grid item xs={6} sm={3}>
                    <Typography variant="caption" color="textSecondary">
                      {intl.formatMessage({ id: 'subscription.trial.expires' })}
                    </Typography>
                    <Typography variant="body1" style={{ fontWeight: 500, color: '#e65100' }}>
                      {this.formatDate(trialEnd)}
                    </Typography>
                  </Grid>
                )}
                {subscriptionStatus && (
                  <Grid item xs={6} sm={3}>
                    <Typography variant="caption" color="textSecondary" style={{ display: 'block' }}>
                      {intl.formatMessage({ id: 'subscription.gateway.status' })}
                    </Typography>
                    <Chip
                      label={subscriptionStatus}
                      size="small"
                      sx={{
                        backgroundColor: this.getStatusColor(subscriptionStatus) + ' !important',
                        color: '#fff !important',
                        marginTop: '6px'
                      }}
                    />
                  </Grid>
                )}
              </Grid>

              {cancelAtPeriodEnd && (
                <div style={{
                  marginTop: 16, padding: '8px 16px',
                  backgroundColor: '#fff3e0', border: '1px solid #ffb74d', borderRadius: 4
                }}>
                  <Typography variant="body2" style={{ color: '#e65100' }}>
                    <WarningIcon style={{ fontSize: 16, verticalAlign: 'middle', marginRight: 4 }} />
                    {intl.formatMessage({ id: 'subscription.cancel.at.period.end' })}
                  </Typography>
                </div>
              )}

              {/* Contracted Products */}
              {this.state.contractProducts.length > 0 && (
                <div style={{ marginTop: 20 }}>
                  <Typography variant="subtitle2" style={{ fontWeight: 600, color: '#424242', marginBottom: 8 }}>
                    {intl.formatMessage({ id: 'subscription.contracted.products' })}
                  </Typography>
                  <TableContainer component={Paper} variant="outlined" style={{ borderRadius: 8 }}>
                    <Table size="small">
                      <TableHead>
                        <TableRow style={{ backgroundColor: '#fafafa' }}>
                          <TableCell style={{ fontWeight: 600, fontSize: 12, textTransform: 'uppercase', color: '#757575' }}>
                            {intl.formatMessage({ id: 'subscription.product' })}
                          </TableCell>
                          <TableCell style={{ fontWeight: 600, fontSize: 12, textTransform: 'uppercase', color: '#757575' }}>
                            {intl.formatMessage({ id: 'subscription.plan.name' })}
                          </TableCell>
                          <TableCell style={{ fontWeight: 600, fontSize: 12, textTransform: 'uppercase', color: '#757575' }}>
                            {intl.formatMessage({ id: 'subscription.periodicity' })}
                          </TableCell>
                          <TableCell style={{ fontWeight: 600, fontSize: 12, textTransform: 'uppercase', color: '#757575' }}>
                            {intl.formatMessage({ id: 'subscription.billing.mode' })}
                          </TableCell>
                          <TableCell align="right" style={{ fontWeight: 600, fontSize: 12, textTransform: 'uppercase', color: '#757575' }}>
                            Valor Contratado
                          </TableCell>
                          <TableCell align="center" style={{ fontWeight: 600, fontSize: 12, textTransform: 'uppercase', color: '#757575' }}>
                            Qtd. Contratada
                          </TableCell>
                          <TableCell align="right" style={{ fontWeight: 600, fontSize: 12, textTransform: 'uppercase', color: '#757575' }}>
                            Valor Total
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {this.state.contractProducts.map((cp, idx) => {
                          const billingMode = cp.billingmode ?? cp.billingMode ?? 'unit'
                          const cppId = cp.id ?? cp.Id ?? 0
                          const creditBalance = billingMode === 'credit'
                            ? this.state.creditBalances.find(cb => (cb.contractplanperiodicityid ?? cb.contractPlanPeriodicityId) === cppId)
                            : null
                          const ppId = cp.planperiodicityid ?? cp.planPeriodicityId ?? 0
                          const isFilterActive = this.state.usageFilterPlanPeriodicityId === ppId
                          // monthly = plan_value_per_month (valor mensal por unidade — sempre mensal canonico)
                          // contractedValue = plan_value (valor por unidade NO PERIODO da periodicidade)
                          //   Mensal -> = monthly; Trimestral -> = monthly*3; Anual -> = monthly*12
                          // qty = quantidade de licenças contratadas
                          // lineTotal = plan_value × quantity (valor total da linha no periodo de cobrança)
                          const monthly = cp.planvaluepermonth ?? cp.planValuePerMonth ?? 0
                          const qty = cp.quantity ?? cp.Quantity ?? 1
                          const contractedValue = cp.planvalue ?? cp.planValue ?? monthly
                          const lineTotal = contractedValue * qty
                          // MRR equivalente da linha (valor mensal total) — mostrado como sub-info
                          const monthlyEquivalent = monthly * qty
                          // Cortesia: plan_value === 0 (produto gratuito como 2TALK hoje)
                          const isCourtesy = contractedValue === 0
                          return (
                            <TableRow key={idx} hover
                              style={{
                                cursor: 'pointer',
                                backgroundColor: isFilterActive ? '#e8f5e9' : undefined,
                                borderLeft: isFilterActive ? '4px solid #8BC34A' : '4px solid transparent',
                                transition: 'all 0.2s'
                              }}
                              onClick={() => this.setState({ usageFilterPlanPeriodicityId: isFilterActive ? null : ppId })}
                            >
                              <TableCell>
                                <Typography variant="body2" style={{ fontWeight: 500 }}>
                                  {cp.applicationname ?? cp.applicationName ?? '-'}
                                </Typography>
                              </TableCell>
                              <TableCell>{cp.planname ?? cp.planName ?? '-'}</TableCell>
                              <TableCell>{cp.periodicityname ?? cp.periodicityName ?? '-'}</TableCell>
                              <TableCell>
                                {billingMode === 'credit' ? (
                                  <Chip label={intl.formatMessage({ id: 'subscription.billing.credit' })} size="small" style={{ backgroundColor: '#e3f2fd', color: '#1565c0', fontWeight: 600 }} />
                                ) : (
                                  <Chip label={intl.formatMessage({ id: 'subscription.billing.unit' })} size="small" style={{ backgroundColor: '#f5f5f5', color: '#616161' }} />
                                )}
                              </TableCell>
                              <TableCell align="right">
                                {isCourtesy ? (
                                  <Chip label="Cortesia" size="small" style={{ backgroundColor: '#e8f5e9', color: '#2e7d32', fontWeight: 600 }} />
                                ) : (
                                  this.formatCurrency(contractedValue, currency)
                                )}
                              </TableCell>
                              <TableCell align="center">{qty}</TableCell>
                              <TableCell align="right" style={{ fontWeight: 600 }}>
                                {isCourtesy ? (
                                  <Typography variant="body2" style={{ color: '#2e7d32', fontWeight: 600 }}>—</Typography>
                                ) : (
                                  <>
                                    <div>{this.formatCurrency(lineTotal, currency)}</div>
                                    {monthlyEquivalent !== lineTotal && (
                                      <Typography variant="caption" style={{ color: '#9e9e9e', fontWeight: 400 }}>
                                        equiv. {this.formatCurrency(monthlyEquivalent, currency)}/mês
                                      </Typography>
                                    )}
                                  </>
                                )}
                              </TableCell>
                            </TableRow>
                          )
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>

                  {/* Credit Balances */}
                  {this.state.creditBalances.length > 0 && (
                    <div style={{ marginTop: 12 }}>
                      <Typography variant="caption" style={{ fontWeight: 700, color: '#757575', textTransform: 'uppercase', letterSpacing: 1 }}>
                        {intl.formatMessage({ id: 'subscription.credit.balances' })}
                      </Typography>
                      <div style={{ display: 'flex', gap: 12, marginTop: 8, flexWrap: 'wrap' }}>
                        {this.state.creditBalances.map((cb, idx) => {
                          const balance = cb.currentbalance ?? cb.currentBalance ?? 0
                          const appName = cb.applicationname ?? cb.applicationName ?? '-'
                          const status = cb.status ?? cb.Status ?? 'confirmed'
                          const isPending = status === 'pending'
                          const threshold = cb.creditalertthreshold ?? cb.creditAlertThreshold
                          const isLow = threshold != null && balance <= threshold
                          return (
                            <Card key={idx} elevation={1} style={{
                              flex: '1 1 200px', maxWidth: 280,
                              border: isLow ? '2px solid #f44336' : '1px solid #e0e0e0',
                              borderRadius: 8
                            }}>
                              <CardContent style={{ padding: '12px 16px' }}>
                                <Typography variant="caption" color="textSecondary">{appName}</Typography>
                                {isPending && (
                                  <Chip label={intl.formatMessage({ id: 'subscription.credit.status.pending' })} size="small" style={{ backgroundColor: '#fff3e0', color: '#e65100', fontWeight: 600, marginTop: 4 }} />
                                )}
                                <Typography variant="h5" style={{ fontWeight: 700, color: isPending ? '#ff9800' : (isLow ? '#c62828' : '#2e7d32'), marginTop: 4 }}>
                                  {this.formatCurrency(balance)}
                                </Typography>
                                <Typography variant="caption" color="textSecondary">
                                  {intl.formatMessage({ id: 'subscription.credit.balance.label' })}
                                </Typography>
                                {isLow && (
                                  <Typography variant="caption" style={{ display: 'block', color: '#c62828', fontWeight: 600, marginTop: 4 }}>
                                    {intl.formatMessage({ id: 'subscription.credit.low.balance' })}
                                  </Typography>
                                )}
                                <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 8 }}>
                                  <Button size="small" onClick={() => this.handleOpenCreditDialog(cb)}
                                    style={{ textTransform: 'none', color: '#8BC34A', fontWeight: 600 }}>
                                    {intl.formatMessage({ id: 'subscription.credit.manage' })}
                                  </Button>
                                </div>
                              </CardContent>
                            </Card>
                          )
                        })}
                      </div>
                    </div>
                  )}
                </div>
              )}

              {this.state.contractProducts.length === 0 && !isPending && (
                <div style={{ marginTop: 20, textAlign: 'center', padding: '16px 0' }}>
                  <Typography variant="body2" color="textSecondary">
                    {intl.formatMessage({ id: 'subscription.no.products' })}
                  </Typography>
                </div>
              )}
            </CardContent>
          </Card>
        </Grid>

        {/* Actions Sidebar */}
        <Grid item xs={12} md={4}>
          {/* Método de Faturamento — destacado acima do bloco Ações */}
          {(() => {
            const gwType = (this.state.subscription?.paymentgatewaytype ?? this.state.subscription?.paymentGatewayType ?? '').toLowerCase()
            const gwName = this.state.subscription?.paymentgatewayname ?? this.state.subscription?.paymentGatewayName
            const isManual = gwType === 'manual'
            const labelGw = isManual ? 'Manual' : (gwName || (gwType ? gwType.charAt(0).toUpperCase() + gwType.slice(1) : 'Gateway Online'))
            const palette = isManual
              ? { iconBg: '#cfd8dc', iconFg: '#37474f', accent: '#546e7a', valueFg: '#263238', cardBg: 'linear-gradient(135deg, #f5f7fa 0%, #eceff1 100%)' }
              : { iconBg: '#c8e6c9', iconFg: '#1b5e20', accent: '#2e7d32', valueFg: '#1b5e20', cardBg: 'linear-gradient(135deg, #f1f8e9 0%, #e8f5e9 100%)' }
            const desc = isManual
              ? 'Cobrança gerenciada pelo financeiro. Boleto/NF emitidos fora da plataforma.'
              : 'Cobrança automática pelo gateway de pagamento.'
            const Icon = isManual ? ReceiptLongIcon : CreditCardIcon
            return (
              <Card elevation={2} style={{
                marginBottom: 12,
                borderLeft: `4px solid ${palette.accent}`,
                background: palette.cardBg,
                overflow: 'hidden'
              }}>
                <CardContent style={{ paddingBottom: 14 }}>
                  <div style={{
                    display: 'flex', alignItems: 'center',
                    textTransform: 'uppercase', letterSpacing: 0.8,
                    color: palette.accent, fontSize: 11, fontWeight: 700, marginBottom: 10
                  }}>
                    <span style={{
                      display: 'inline-block', width: 6, height: 6, borderRadius: '50%',
                      backgroundColor: palette.accent, marginRight: 8
                    }} />
                    Método de Faturamento
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
                    <div style={{
                      width: 44, height: 44, borderRadius: 10,
                      backgroundColor: palette.iconBg,
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      flexShrink: 0
                    }}>
                      <Icon style={{ color: palette.iconFg, fontSize: 24 }} />
                    </div>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <Typography style={{ fontWeight: 700, fontSize: 18, color: palette.valueFg, lineHeight: 1.1 }}>
                        {labelGw}
                      </Typography>
                      <Typography style={{ fontSize: 12, color: '#607d8b', marginTop: 4, lineHeight: 1.4 }}>
                        {desc}
                      </Typography>
                    </div>
                  </div>
                </CardContent>
              </Card>
            )
          })()}

          <Card elevation={2}>
            <CardContent>
              <Typography variant="subtitle1" style={{ fontWeight: 600, marginBottom: 16 }}>
                {intl.formatMessage({ id: 'subscription.actions' })}
              </Typography>

              {/* Subscribe CTA — Trial or Pending/No Plan */}
              {(isTrial || (isPending && !hasPlan)) && (
                <Button
                  fullWidth
                  variant="contained"
                  size="large"
                  startIcon={<ShoppingCartIcon />}
                  style={{
                    backgroundColor: '#8BC34A', color: '#fff',
                    marginBottom: 12, textTransform: 'none', fontWeight: 600
                  }}
                  onClick={this.handleOpenPlanSelection}
                  disabled={this.state.checkoutLoading || this.state.loadingPlans}
                >
                  {(this.state.checkoutLoading || this.state.loadingPlans)
                    ? <CircularProgress size={24} style={{ color: '#fff' }} />
                    : intl.formatMessage({ id: 'subscription.subscribe.now' })
                  }
                </Button>
              )}

              {/* Change Plan (only if active) */}
              {isActive && (
                <Button
                  fullWidth
                  variant="outlined"
                  startIcon={this.state.changePlanLoading ? <CircularProgress size={20} /> : <CompareArrowsIcon />}
                  style={{
                    marginBottom: 12, textTransform: 'none',
                    borderColor: '#277afe', color: '#277afe'
                  }}
                  onClick={this.handleOpenChangePlan}
                  disabled={this.state.changePlanLoading}
                >
                  {intl.formatMessage({ id: 'subscription.change.plan' })}
                </Button>
              )}

              {/* Cancel (only if active, not already canceling) */}
              {isActive && hasSubscription && !cancelAtPeriodEnd && (
                <Button
                  fullWidth
                  variant="outlined"
                  color="error"
                  startIcon={<CancelIcon />}
                  style={{ marginBottom: 12, textTransform: 'none' }}
                  onClick={this.handleOpenCancelProducts}
                >
                  {intl.formatMessage({ id: 'subscription.cancel.subscription' })}
                </Button>
              )}

              {/* Suspended message */}
              {isSuspended && (
                <div style={{
                  padding: '12px 16px', backgroundColor: '#ffebee',
                  border: '1px solid #ef9a9a', borderRadius: 4, marginBottom: 12
                }}>
                  <Typography variant="body2" style={{ color: '#c62828' }}>
                    <ErrorIcon style={{ fontSize: 16, verticalAlign: 'middle', marginRight: 4 }} />
                    {intl.formatMessage({ id: 'subscription.suspended.message' })}
                  </Typography>
                </div>
              )}

              {/* Canceled / Expired — Reactivate */}
              {(isCanceled || isExpired) && (
                <>
                  <div style={{
                    padding: '12px 16px', backgroundColor: '#fafafa',
                    border: '1px solid #e0e0e0', borderRadius: 4, marginBottom: 12
                  }}>
                    <Typography variant="body2" color="textSecondary">
                      {intl.formatMessage({ id: 'subscription.canceled.message' })}
                    </Typography>
                  </div>
                  <Button
                    fullWidth
                    variant="contained"
                    startIcon={this.state.reactivateLoading ? <CircularProgress size={20} style={{ color: '#fff' }} /> : <RestoreIcon />}
                    style={{
                      backgroundColor: '#4caf50', color: '#fff',
                      marginBottom: 12, textTransform: 'none', fontWeight: 600
                    }}
                    onClick={this.handleOpenReactivate}
                    disabled={this.state.reactivateLoading}
                  >
                    {intl.formatMessage({ id: 'subscription.reactivate' })}
                  </Button>
                </>
              )}

              <Divider style={{ marginBottom: 16 }} />

              {/* Payment Method Summary */}
              <Typography variant="subtitle2" color="textSecondary" style={{ marginBottom: 8 }}>
                {intl.formatMessage({ id: 'subscription.payment.method' })}
              </Typography>
              {paymentMethods.length > 0 ? (
                paymentMethods.filter(pm => pm.isdefault || pm.isDefault).map((pm, idx) => (
                  <div key={idx} style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
                    <CreditCardIcon style={{ color: '#1976d2', marginRight: 8 }} />
                    <div>
                      <Typography variant="body2" style={{ fontWeight: 500 }}>
                        {(pm.cardbrand || pm.cardBrand || '').toUpperCase()} **** {pm.cardlast4 || pm.cardLast4}
                      </Typography>
                      <Typography variant="caption" color="textSecondary">
                        {intl.formatMessage({ id: 'subscription.expires' })} {pm.cardexpmonth || pm.cardExpMonth}/{pm.cardexpyear || pm.cardExpYear}
                      </Typography>
                    </div>
                  </div>
                ))
              ) : (
                <Typography variant="body2" color="textSecondary">
                  {intl.formatMessage({ id: 'subscription.no.payment.method' })}
                </Typography>
              )}
            </CardContent>
          </Card>
        </Grid>

        {/* Usage Cards */}
        <Grid item xs={12}>
          <Typography variant="subtitle1" style={{ fontWeight: 600, marginBottom: 12, color: '#424242' }}>
            {intl.formatMessage({ id: 'subscription.current.usage' })}
            {(() => {
              const filteredPpId = this.state.usageFilterPlanPeriodicityId
              if (filteredPpId) {
                const cp = this.state.contractProducts.find(p => (p.planperiodicityid ?? p.planPeriodicityId) === filteredPpId)
                return cp ? (
                  <span style={{ marginLeft: 8, padding: '2px 10px', backgroundColor: '#f1f8e9', border: '1px solid #8BC34A', borderRadius: 12, fontSize: 13, color: '#558B2F', fontWeight: 600 }}>
                    {cp.applicationname ?? cp.applicationName ?? '-'}
                  </span>
                ) : null
              }
              return <span style={{ marginLeft: 8, fontSize: 13, color: '#757575' }}>({intl.formatMessage({ id: 'subscription.usage.general' })})</span>
            })()}
          </Typography>
          <Grid container spacing={2}>
            {(() => {
              const defaultTypes = [
                { usagetype: 'agent', quantity: 0, includedquantity: 0 },
                { usagetype: 'disk_mb', quantity: 0, includedquantity: 0 },
                { usagetype: 'attendance', quantity: 0, includedquantity: 0 },
              ]
              const filteredPpId = this.state.usageFilterPlanPeriodicityId
              const rawData = this.state.usageData.length > 0 ? this.state.usageData : defaultTypes
              let data
              if (filteredPpId) {
                // Modo produto: filtra por plan_periodicity_id
                data = rawData.filter(u => {
                  const ppId = u.planperiodicityid ?? u.planPeriodicityId
                  return ppId === filteredPpId || ppId == null
                })
              } else {
                // Modo geral: agrupa por usage_type, soma quantidades e limites
                const grouped = {}
                rawData.forEach(u => {
                  const type = (u.usagetype || u.usageType || '').toLowerCase()
                  if (!grouped[type]) {
                    grouped[type] = { usagetype: type, quantity: 0, includedquantity: 0, overagequantity: 0, unitvalue: 0 }
                  }
                  const qty = u.quantity ?? u.Quantity ?? 0
                  const inc = u.includedquantity ?? u.includedQuantity ?? 0
                  if (type === 'agent') {
                    // Agentes: mesma quantidade, soma limites
                    grouped[type].quantity = Math.max(grouped[type].quantity, qty)
                    grouped[type].includedquantity += inc
                  } else {
                    // Atendimentos, disco, etc: soma tudo
                    grouped[type].quantity += qty
                    grouped[type].includedquantity += inc
                  }
                })
                data = Object.values(grouped)
              }
              return data.map((usage, idx) => {
                const usageType = usage.usagetype || usage.usageType || usage.UsageType || ''
                const quantity = usage.quantity || usage.Quantity || 0
                const included = usage.includedquantity || usage.includedQuantity || usage.IncludedQuantity || 0
                const isUnlimited = included === -1
                const percent = isUnlimited ? 0 : (included > 0 ? Math.min((quantity / included) * 100, 100) : 0)
                const isOverage = !isUnlimited && quantity > included

                const typeConfig = {
                  'agent': { icon: <PeopleIcon />, label: intl.formatMessage({ id: 'subscription.usage.agents' }), color: '#1976d2' },
                  'disk_mb': { icon: <StorageIcon />, label: intl.formatMessage({ id: 'subscription.usage.disk' }), color: '#7b1fa2' },
                  'attendance': { icon: <SupportAgentIcon />, label: intl.formatMessage({ id: 'subscription.usage.attendances' }), color: '#e65100' },
                  'whatsapp_message': { icon: <SupportAgentIcon />, label: 'WhatsApp', color: '#25D366' },
                  'instagram_message': { icon: <SupportAgentIcon />, label: 'Instagram', color: '#E1306C' },
                  'messenger_message': { icon: <SupportAgentIcon />, label: 'Messenger', color: '#0084FF' },
                  'telegram_message': { icon: <SupportAgentIcon />, label: 'Telegram', color: '#0088cc' },
                  'webchat_message': { icon: <SupportAgentIcon />, label: 'WebChat', color: '#607D8B' },
                }
                const config = typeConfig[usageType.toLowerCase()] || { icon: <InfoIcon />, label: usageType, color: '#757575' }

                return (
                  <Grid item xs={12} sm={4} key={idx}>
                    <Card elevation={1} style={{ borderTop: `3px solid ${config.color}` }}>
                      <CardContent>
                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
                          <div style={{ color: config.color, marginRight: 8 }}>{config.icon}</div>
                          <Typography variant="subtitle2" style={{ fontWeight: 600 }}>{config.label}</Typography>
                        </div>
                        <Typography variant="h5" style={{ fontWeight: 700, color: isOverage ? '#f44336' : '#212121' }}>
                          {usageType.toLowerCase() === 'disk'
                            ? `${(quantity / (1024 * 1024 * 1024)).toFixed(1)} GB`
                            : quantity.toLocaleString('pt-BR')
                          }
                        </Typography>
                        <Typography variant="caption" color="textSecondary">
                          {isUnlimited
                            ? intl.formatMessage({ id: 'subscription.usage.unlimited' })
                            : `${intl.formatMessage({ id: 'subscription.usage.of' })} ${
                                usageType.toLowerCase() === 'disk'
                                  ? `${(included / (1024 * 1024 * 1024)).toFixed(0)} GB`
                                  : included.toLocaleString('pt-BR')
                              }`
                          }
                        </Typography>
                        {!isUnlimited && (
                          <LinearProgress
                            variant="determinate"
                            value={percent}
                            style={{ marginTop: 8, height: 6, borderRadius: 3 }}
                            sx={{
                              '& .MuiLinearProgress-bar': {
                                backgroundColor: isOverage ? '#f44336' : percent > 80 ? '#ff9800' : config.color
                              },
                              backgroundColor: '#e0e0e0'
                            }}
                          />
                        )}
                      </CardContent>
                    </Card>
                  </Grid>
                )
              })
            })()}
          </Grid>
        </Grid>

        {/* Plan Features */}
        {this.state.planFeatures.length > 0 && (
          <Grid item xs={12}>
            <Card elevation={1}>
              <CardContent>
                <Typography variant="subtitle1" style={{ fontWeight: 600, marginBottom: 12 }}>
                  {intl.formatMessage({ id: 'subscription.plan.features' })}
                </Typography>
                {(() => {
                  // Agrupar por application
                  const grouped = {}
                  this.state.planFeatures.forEach(pf => {
                    const appName = pf.applicationname || pf.applicationName || 'Geral'
                    if (!grouped[appName]) grouped[appName] = []
                    grouped[appName].push(pf)
                  })

                  return Object.entries(grouped).map(([appName, features], gIdx) => (
                    <div key={gIdx} style={{ marginBottom: gIdx < Object.keys(grouped).length - 1 ? 16 : 0 }}>
                      {Object.keys(grouped).length > 1 && (
                        <Typography variant="caption" style={{ fontWeight: 700, color: '#757575', textTransform: 'uppercase', letterSpacing: 1 }}>
                          {appName}
                        </Typography>
                      )}
                      <Grid container spacing={1} style={{ marginTop: 4 }}>
                        {features.map((pf, idx) => {
                          const featureName = pf.featurename || pf.featureName || pf.FeatureName || ''
                          return (
                            <Grid item xs={12} sm={6} md={4} key={idx}>
                              <div style={{ display: 'flex', alignItems: 'center', padding: '4px 0' }}>
                                <CheckCircleIcon style={{ fontSize: 18, color: '#4caf50', marginRight: 8 }} />
                                <Typography variant="body2">{featureName}</Typography>
                              </div>
                            </Grid>
                          )
                        })}
                      </Grid>
                    </div>
                  ))
                })()}
              </CardContent>
            </Card>
          </Grid>
        )}

      </Grid>
    )
  }

  // ── RENDER: Invoices Tab ──

  renderInvoicesTab() {
    const { invoices, invoicesTotalCount, invoicesPage, upcomingInvoice, loadingUpcoming, subscription } = this.state
    const intl = this.props.intl
    const totalPages = Math.ceil(invoicesTotalCount / PAGE_SIZE_INVOICES)
    const gwType = (subscription?.paymentgatewaytype ?? subscription?.paymentGatewayType ?? '').toLowerCase()
    const isManual = gwType === 'manual'

    return (
      <div style={{ marginTop: 16 }}>
        {isManual && (
          <div style={{
            padding: '12px 16px', marginBottom: 16, borderRadius: 8,
            backgroundColor: '#eceff1', borderLeft: '4px solid #546e7a',
            display: 'flex', alignItems: 'flex-start', gap: 12
          }}>
            <InfoIcon style={{ color: '#546e7a', fontSize: 22, marginTop: 2 }} />
            <div>
              <Typography variant="body2" style={{ fontWeight: 600, color: '#37474f', marginBottom: 4 }}>
                Faturamento Manual
              </Typography>
              <Typography variant="body2" style={{ color: '#546e7a' }}>
                As faturas (boletos, NFs) desta assinatura são emitidas pela equipe financeira fora da plataforma.
                Em caso de dúvida sobre cobranças, entre em contato com o financeiro.
              </Typography>
            </div>
          </div>
        )}

        {/* Upcoming Invoice — só faz sentido pra gateway online (calcula via API do gateway). */}
        {!isManual && (
          <div style={{ marginBottom: 16, display: 'flex', alignItems: 'center', gap: 12 }}>
            <Button
              variant="outlined"
              size="small"
              startIcon={loadingUpcoming ? <CircularProgress size={16} /> : <EventIcon />}
              onClick={() => this.loadUpcomingInvoice()}
              disabled={loadingUpcoming}
              style={{ textTransform: 'none' }}
            >
              {intl.formatMessage({ id: 'subscription.view.upcoming.invoice' })}
            </Button>
          </div>
        )}

        {upcomingInvoice && (
          <Card elevation={1} style={{ marginBottom: 16, backgroundColor: '#e3f2fd' }}>
            <CardContent style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div>
                <Typography variant="subtitle2" style={{ color: '#1565c0' }}>
                  {intl.formatMessage({ id: 'subscription.upcoming.invoice' })}
                </Typography>
                <Typography variant="body2">
                  {intl.formatMessage({ id: 'subscription.amount' })}: {this.formatCurrency(
                    (upcomingInvoice.amountdue || upcomingInvoice.amountDue || 0) / 100,
                    upcomingInvoice.currency
                  )}
                </Typography>
              </div>
              <Typography variant="body2" color="textSecondary">
                {intl.formatMessage({ id: 'subscription.due.date' })}: {this.formatDate(upcomingInvoice.duedate || upcomingInvoice.dueDate || upcomingInvoice.nextpaymentattempt)}
              </Typography>
            </CardContent>
          </Card>
        )}

        {/* Invoice Table */}
        <TableContainer component={Paper} elevation={1}>
          <Table size="small">
            <TableHead>
              <TableRow style={{ backgroundColor: '#fafafa' }}>
                <TableCell style={{ fontWeight: 600 }}>{intl.formatMessage({ id: 'subscription.invoice.number' })}</TableCell>
                <TableCell style={{ fontWeight: 600 }}>{intl.formatMessage({ id: 'subscription.status' })}</TableCell>
                <TableCell style={{ fontWeight: 600 }}>{intl.formatMessage({ id: 'subscription.amount' })}</TableCell>
                <TableCell style={{ fontWeight: 600 }}>{intl.formatMessage({ id: 'subscription.due.date' })}</TableCell>
                <TableCell style={{ fontWeight: 600 }}>{intl.formatMessage({ id: 'subscription.paid.date' })}</TableCell>
                <TableCell style={{ fontWeight: 600 }} align="right">{intl.formatMessage({ id: 'subscription.actions.column' })}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {invoices.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={6} align="center">
                    <Typography variant="body2" color="textSecondary" style={{ padding: 24 }}>
                      {intl.formatMessage({ id: 'subscription.no.invoices' })}
                    </Typography>
                  </TableCell>
                </TableRow>
              ) : (
                invoices.map((inv, idx) => {
                  const status = inv.status || ''
                  const invoiceUrl = inv.hostedinvoiceurl || inv.hostedInvoiceUrl || inv.hosted_invoice_url
                  const pdfUrl = inv.invoicepdfurl || inv.invoicePdfUrl || inv.invoice_pdf_url
                  const invoiceId = inv.gatewayinvoiceid || inv.gatewayInvoiceId || inv.id

                  return (
                    <TableRow key={idx} hover>
                      <TableCell>{inv.invoicenumber || inv.invoiceNumber || inv.invoice_number || '-'}</TableCell>
                      <TableCell>
                        <Chip
                          label={status}
                          size="small"
                          style={{ backgroundColor: this.getStatusColor(status), color: '#fff', fontWeight: 500 }}
                        />
                      </TableCell>
                      <TableCell>{this.formatCurrency(inv.valueinvoice ?? inv.valueInvoice ?? inv.value_invoice ?? 0, inv.currency)}</TableCell>
                      <TableCell>{this.formatDate(inv.duedate ?? inv.dueDate ?? inv.dateinvoice ?? inv.dateInvoice)}</TableCell>
                      <TableCell>{this.formatDate(inv.datepaidinvoice ?? inv.datePaidInvoice ?? inv.date_paid_invoice)}</TableCell>
                      <TableCell align="right">
                        {pdfUrl && (
                          <Tooltip title="PDF">
                            <IconButton size="small" onClick={() => window.open(pdfUrl, '_blank')}>
                              <PictureAsPdfIcon fontSize="small" style={{ color: '#e53935' }} />
                            </IconButton>
                          </Tooltip>
                        )}
                        {invoiceUrl && (
                          <Tooltip title={intl.formatMessage({ id: 'subscription.view.invoice' })}>
                            <IconButton size="small" onClick={() => window.open(invoiceUrl, '_blank')}>
                              <OpenInNewIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        )}
                        {status === 'open' && (
                          <Tooltip title={intl.formatMessage({ id: 'subscription.retry.payment' })}>
                            <IconButton size="small" onClick={() => this.handleRetryPayment(invoiceId)}>
                              <RefreshIcon fontSize="small" style={{ color: '#ff9800' }} />
                            </IconButton>
                          </Tooltip>
                        )}
                      </TableCell>
                    </TableRow>
                  )
                })
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {totalPages > 1 && (
          <div style={{ display: 'flex', justifyContent: 'center', marginTop: 16 }}>
            <Pagination
              count={totalPages}
              page={invoicesPage}
              onChange={(e, page) => this.setState({ invoicesPage: page }, () => this.loadInvoices())}
              color="primary"
            />
          </div>
        )}
      </div>
    )
  }

  // ── RENDER: Payment Methods Tab ──

  renderPaymentTab() {
    const { paymentMethods, loadingPaymentMethods, subscription } = this.state
    const intl = this.props.intl
    // Quando o gateway é manual, faturamento é gerenciado fora da plataforma — não faz
    // sentido cadastrar cartão de crédito (não vai ser cobrado por gateway).
    const gwType = (subscription?.paymentgatewaytype ?? subscription?.paymentGatewayType ?? '').toLowerCase()
    const isManual = gwType === 'manual'

    return (
      <div style={{ marginTop: 16 }}>
        {isManual && (
          <div style={{
            padding: '12px 16px', marginBottom: 16, borderRadius: 8,
            backgroundColor: '#eceff1', borderLeft: '4px solid #546e7a',
            display: 'flex', alignItems: 'flex-start', gap: 12
          }}>
            <InfoIcon style={{ color: '#546e7a', fontSize: 22, marginTop: 2 }} />
            <div>
              <Typography variant="body2" style={{ fontWeight: 600, color: '#37474f', marginBottom: 4 }}>
                Faturamento Manual
              </Typography>
              <Typography variant="body2" style={{ color: '#546e7a' }}>
                A cobrança desta assinatura é gerenciada pela equipe financeira (boleto/NF emitida fora da plataforma).
                Não é necessário cadastrar cartão.
              </Typography>
            </div>
          </div>
        )}

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
          <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
            {intl.formatMessage({ id: 'subscription.your.cards' })}
          </Typography>
          <Tooltip title={isManual ? 'Indisponível em faturamento manual' : ''}>
            <span>
              <Button
                variant="contained"
                size="small"
                startIcon={<AddIcon />}
                style={{
                  backgroundColor: isManual ? '#bdbdbd' : '#1976d2',
                  color: '#fff', textTransform: 'none',
                  cursor: isManual ? 'not-allowed' : 'pointer'
                }}
                onClick={this.handleAddCard}
                disabled={isManual}
              >
                {intl.formatMessage({ id: 'subscription.add.card' })}
              </Button>
            </span>
          </Tooltip>
        </div>

        {loadingPaymentMethods ? (
          <Card elevation={1}>
            <CardContent style={{ textAlign: 'center', padding: 40 }}>
              <CircularProgress size={32} />
              <Typography variant="body2" color="textSecondary" style={{ marginTop: 8 }}>
                {intl.formatMessage({ id: 'loading' })}
              </Typography>
            </CardContent>
          </Card>
        ) : paymentMethods.length === 0 ? (
          <Card elevation={1}>
            <CardContent style={{ textAlign: 'center', padding: 40 }}>
              <CreditCardIcon style={{ fontSize: 48, color: '#bdbdbd', marginBottom: 8 }} />
              <Typography variant="body1" color="textSecondary">
                {intl.formatMessage({ id: 'subscription.no.payment.methods' })}
              </Typography>
            </CardContent>
          </Card>
        ) : (
          <Grid container spacing={2}>
            {paymentMethods.map((pm, idx) => {
              const isDefault = pm.isdefault || pm.isDefault
              const brand = (pm.cardbrand || pm.cardBrand || 'card').toUpperCase()
              const last4 = pm.cardlast4 || pm.cardLast4 || '****'
              const expMonth = pm.cardexpmonth || pm.cardExpMonth
              const expYear = pm.cardexpyear || pm.cardExpYear
              const pmId = pm.gatewaypaymentmethodid || pm.gatewayPaymentMethodId || pm.id

              return (
                <Grid item xs={12} sm={6} md={4} key={idx}>
                  <Card elevation={isDefault ? 3 : 1} style={{
                    border: isDefault ? '2px solid #1976d2' : '1px solid #e0e0e0',
                    position: 'relative'
                  }}>
                    {isDefault && (
                      <Chip
                        label={intl.formatMessage({ id: 'subscription.default' })}
                        size="small"
                        style={{
                          position: 'absolute', top: 8, right: 8,
                          backgroundColor: '#1976d2', color: '#fff', fontSize: 11
                        }}
                      />
                    )}
                    <CardContent>
                      <div style={{ display: 'flex', alignItems: 'center', marginBottom: 12 }}>
                        <CreditCardIcon style={{ fontSize: 32, color: '#424242', marginRight: 12 }} />
                        <div>
                          <Typography variant="subtitle1" style={{ fontWeight: 600 }}>{brand}</Typography>
                          <Typography variant="body2" color="textSecondary">**** **** **** {last4}</Typography>
                        </div>
                      </div>
                      <Typography variant="caption" color="textSecondary">
                        {intl.formatMessage({ id: 'subscription.expires' })} {expMonth}/{expYear}
                      </Typography>
                      <div style={{ marginTop: 12, display: 'flex', gap: 8 }}>
                        {!isDefault && (
                          <Tooltip title={intl.formatMessage({ id: 'subscription.set.default' })}>
                            <IconButton size="small" onClick={() => this.handleSetDefault(pmId)}>
                              <StarBorderIcon fontSize="small" style={{ color: '#ff9800' }} />
                            </IconButton>
                          </Tooltip>
                        )}
                        {!isDefault && (
                          <Tooltip title={intl.formatMessage({ id: 'subscription.remove.card' })}>
                            <IconButton size="small" onClick={() => this.setState({ deleteDialogOpen: true, deleteTarget: pmId })}>
                              <DeleteIcon fontSize="small" style={{ color: '#e53935' }} />
                            </IconButton>
                          </Tooltip>
                        )}
                        {isDefault && (
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            <StarIcon style={{ fontSize: 18, color: '#ff9800', marginRight: 4 }} />
                            <Typography variant="caption" style={{ color: '#ff9800' }}>
                              {intl.formatMessage({ id: 'subscription.primary.card' })}
                            </Typography>
                          </div>
                        )}
                      </div>
                    </CardContent>
                  </Card>
                </Grid>
              )
            })}
          </Grid>
        )}
      </div>
    )
  }

  // ── RENDER: History Tab ──

  renderHistoryTab() {
    const { events, historyTotalCount, historyPage } = this.state
    const intl = this.props.intl
    const totalPages = Math.ceil(historyTotalCount / PAGE_SIZE_HISTORY)

    const getEventIcon = (type) => {
      switch (type) {
        case 'subscription_event': return <SwapHorizIcon style={{ color: '#2196f3' }} />
        case 'plan_change': return <UpgradeIcon style={{ color: '#9c27b0' }} />
        case 'payment': case 'payment_succeeded': return <PaymentIcon style={{ color: '#4caf50' }} />
        case 'payment_failed': return <ErrorIcon style={{ color: '#f44336' }} />
        case 'checkout_completed': return <ShoppingCartIcon style={{ color: '#1976d2' }} />
        case 'auto_suspension': return <CancelIcon style={{ color: '#f44336' }} />
        default: return <HistoryIcon style={{ color: '#757575' }} />
      }
    }

    return (
      <div style={{ marginTop: 16 }}>
        {events.length === 0 ? (
          <Card elevation={1}>
            <CardContent style={{ textAlign: 'center', padding: 40 }}>
              <HistoryIcon style={{ fontSize: 48, color: '#bdbdbd', marginBottom: 8 }} />
              <Typography variant="body1" color="textSecondary">
                {intl.formatMessage({ id: 'subscription.no.history' })}
              </Typography>
            </CardContent>
          </Card>
        ) : (
          events.map((evt, idx) => {
            const eventType = evt.eventtype || evt.eventType || ''
            const description = evt.description || ''
            const oldStatus = evt.oldstatus || evt.oldStatus
            const newStatus = evt.newstatus || evt.newStatus
            const amount = evt.amount
            const eventDate = evt.eventdate || evt.eventDate || evt.createdat || evt.createdAt

            return (
              <Card key={idx} elevation={1} style={{ marginBottom: 8 }}>
                <CardContent style={{ padding: '12px 16px' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                      {getEventIcon(eventType)}
                      <div>
                        <Chip label={eventType.replace(/_/g, ' ')} size="small"
                          style={{ fontSize: 11, fontWeight: 500, marginBottom: 4 }} />
                        {description && (
                          <Typography variant="body2" style={{ marginTop: 2 }}>{description}</Typography>
                        )}
                        {oldStatus && newStatus && (
                          <Typography variant="caption" color="textSecondary">
                            {oldStatus} → {newStatus}
                          </Typography>
                        )}
                        {amount != null && (
                          <Typography variant="body2" style={{ color: '#4caf50', fontWeight: 500, marginTop: 2 }}>
                            {this.formatCurrency(amount)}
                          </Typography>
                        )}
                      </div>
                    </div>
                    <Typography variant="caption" color="textSecondary" style={{ whiteSpace: 'nowrap' }}>
                      {this.formatDateTime(eventDate)}
                    </Typography>
                  </div>
                </CardContent>
              </Card>
            )
          })
        )}

        {totalPages > 1 && (
          <div style={{ display: 'flex', justifyContent: 'center', marginTop: 16 }}>
            <Pagination
              count={totalPages}
              page={historyPage}
              onChange={(e, page) => this.setState({ historyPage: page }, () => this.loadHistory())}
              color="primary"
            />
          </div>
        )}
      </div>
    )
  }

  // ── RENDER: Products Tab ──

  renderProductsTab() {
    const { contractProducts, loadingProducts, hirerId } = this.state
    const intl = this.props.intl
    const lang = this.props.match.params.lang

    return (
      <div style={{ marginTop: 16 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
          <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
            {intl.formatMessage({ id: 'my.products.title' })}
          </Typography>
          <Button
            variant="contained"
            size="small"
            startIcon={<AddShoppingCartIcon />}
            onClick={() => this.props.history.push(`/${lang}/add-product`)}
            style={{ backgroundColor: '#8BC34A', color: '#fff', textTransform: 'none', fontWeight: 600 }}
          >
            {intl.formatMessage({ id: 'my.products.add' })}
          </Button>
        </div>

        {loadingProducts ? (
          <div style={{ textAlign: 'center', padding: 40 }}>
            <CircularProgress />
          </div>
        ) : contractProducts.length === 0 ? (
          <Card elevation={1}>
            <CardContent style={{ textAlign: 'center', padding: 40 }}>
              <InventoryIcon style={{ fontSize: 56, color: '#bdbdbd', marginBottom: 12 }} />
              <Typography variant="h6" style={{ fontWeight: 600, fontSize: 18, marginBottom: 4 }}>
                {intl.formatMessage({ id: 'my.products.empty' })}
              </Typography>
              <Typography variant="body2" color="textSecondary" style={{ fontSize: 14, marginBottom: 16 }}>
                {intl.formatMessage({ id: 'my.products.empty.description' })}
              </Typography>
              <Button
                variant="contained"
                startIcon={<AddShoppingCartIcon />}
                onClick={() => this.props.history.push(`/${lang}/add-product`)}
                style={{ backgroundColor: '#8BC34A', color: '#fff', textTransform: 'none' }}
              >
                {intl.formatMessage({ id: 'my.products.add.first' })}
              </Button>
            </CardContent>
          </Card>
        ) : (
          <TableContainer component={Paper} elevation={1}>
            <Table size="small">
              <TableHead>
                <TableRow style={{ backgroundColor: '#fafafa' }}>
                  <TableCell style={{ fontWeight: 600 }}>{intl.formatMessage({ id: 'my.products.col.product' })}</TableCell>
                  <TableCell style={{ fontWeight: 600 }}>{intl.formatMessage({ id: 'my.products.col.plan' })}</TableCell>
                  <TableCell style={{ fontWeight: 600 }}>{intl.formatMessage({ id: 'my.products.col.periodicity' })}</TableCell>
                  <TableCell align="right" style={{ fontWeight: 600 }}>Valor Contratado</TableCell>
                  <TableCell align="center" style={{ fontWeight: 600 }}>Qtd. Contratada</TableCell>
                  <TableCell align="right" style={{ fontWeight: 600 }}>Valor Total</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {contractProducts.map((p, idx) => {
                  const name = p.applicationname || p.applicationName || '-'
                  const plan = p.planname || p.planName || '-'
                  const periodicity = p.periodicityname || p.periodicityName || '-'
                  const monthly = p.planvaluepermonth ?? p.planValuePerMonth ?? 0
                  const quantity = p.quantity ?? p.Quantity ?? 1
                  // contractedValue = plan_value (preço por unidade no período de cobrança)
                  const contractedValue = p.planvalue ?? p.planValue ?? monthly
                  const lineTotal = contractedValue * quantity
                  const monthlyEquivalent = monthly * quantity
                  const isCourtesy = contractedValue === 0

                  return (
                    <TableRow key={idx} hover>
                      <TableCell>
                        <Typography variant="body2" style={{ fontWeight: 500 }}>{name}</Typography>
                      </TableCell>
                      <TableCell>
                        <Chip label={plan} size="small" style={{ backgroundColor: '#e3f2fd', color: '#1565c0' }} />
                      </TableCell>
                      <TableCell>{periodicity}</TableCell>
                      <TableCell align="right" style={{ fontWeight: 500 }}>
                        {isCourtesy ? (
                          <Chip label="Cortesia" size="small" style={{ backgroundColor: '#e8f5e9', color: '#2e7d32', fontWeight: 600 }} />
                        ) : (
                          this.formatCurrency(contractedValue)
                        )}
                      </TableCell>
                      <TableCell align="center">{quantity}</TableCell>
                      <TableCell align="right" style={{ fontWeight: 600 }}>
                        {isCourtesy ? (
                          <Typography variant="body2" style={{ color: '#2e7d32', fontWeight: 600 }}>—</Typography>
                        ) : (
                          <>
                            <div>{this.formatCurrency(lineTotal)}</div>
                            {monthlyEquivalent !== lineTotal && (
                              <Typography variant="caption" style={{ color: '#9e9e9e' }}>
                                equiv. {this.formatCurrency(monthlyEquivalent)}/mês
                              </Typography>
                            )}
                          </>
                        )}
                      </TableCell>
                    </TableRow>
                  )
                })}
              </TableBody>
            </Table>
            {/* Valor Geral abaixo do grid */}
            <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', padding: '12px 16px', backgroundColor: '#f5f7fa', borderTop: '1px solid #e0e0e0' }}>
              <Typography variant="body2" style={{ color: '#616161', marginRight: 12 }}>Valor Geral:</Typography>
              <Typography variant="h6" style={{ fontWeight: 700, color: '#277afe' }}>
                {(() => {
                  // Total = soma de plan_value × quantity de cada produto.
                  // Itens com plan_value=0 (cortesia) nao somam.
                  const total = contractProducts.reduce((sum, p) => {
                    const monthly = p.planvaluepermonth ?? p.planValuePerMonth ?? 0
                    const qty = p.quantity ?? p.Quantity ?? 1
                    const contractedValue = p.planvalue ?? p.planValue ?? monthly
                    return sum + (contractedValue * qty)
                  }, 0)
                  return this.formatCurrency(total)
                })()}
              </Typography>
            </div>
          </TableContainer>
        )}
      </div>
    )
  }

  // ── MAIN RENDER ──

  render() {
    const { classes, headerMenu } = this.props
    const intl = this.props.intl
    const { tabValue } = this.state

    return (
      <div className={classes.root} style={{ paddingLeft: 0, marginLeft: 0 }}>
        <HeaderMenu />
        <main className={clsx(classes.content, { [classes.contentShift]: headerMenu.open })}>
          <div className={classes.drawerHeader} />
          <Container component='main' maxWidth='lg' style={{ paddingLeft: 24 }}>
            <CssBaseline />

            <Typography variant="h5" style={{ fontWeight: 700, marginBottom: 4, marginTop: 16 }}>
              {intl.formatMessage({ id: 'subscription.management.title' })}
            </Typography>
            <Typography variant="body2" color="textSecondary" style={{ marginBottom: 20 }}>
              {intl.formatMessage({ id: 'subscription.management.subtitle' })}
            </Typography>

            <Tabs
              value={tabValue}
              onChange={this.handleTabChange}
              indicatorColor="primary"
              textColor="primary"
              style={{ borderBottom: '1px solid #e0e0e0' }}
            >
              <Tab
                label={intl.formatMessage({ id: 'subscription.tab.overview' })}
                icon={<InfoIcon style={{ fontSize: 20 }} />}
                iconPosition="start"
                style={{ textTransform: 'none', fontWeight: 500 }}
              />
              <Tab
                label={intl.formatMessage({ id: 'my.products' })}
                icon={<InventoryIcon style={{ fontSize: 20 }} />}
                iconPosition="start"
                style={{ textTransform: 'none', fontWeight: 500 }}
              />
              <Tab
                label={intl.formatMessage({ id: 'subscription.tab.payment' })}
                icon={<CreditCardIcon style={{ fontSize: 20 }} />}
                iconPosition="start"
                style={{ textTransform: 'none', fontWeight: 500 }}
              />
              <Tab
                label={intl.formatMessage({ id: 'subscription.tab.invoices' })}
                icon={<ReceiptIcon style={{ fontSize: 20 }} />}
                iconPosition="start"
                style={{ textTransform: 'none', fontWeight: 500 }}
              />
              <Tab
                label={intl.formatMessage({ id: 'subscription.tab.history' })}
                icon={<HistoryIcon style={{ fontSize: 20 }} />}
                iconPosition="start"
                style={{ textTransform: 'none', fontWeight: 500 }}
              />
            </Tabs>

            {tabValue === 0 && this.renderOverviewTab()}
            {tabValue === 1 && this.renderProductsTab()}
            {tabValue === 2 && this.renderPaymentTab()}
            {tabValue === 3 && this.renderInvoicesTab()}
            {tabValue === 4 && this.renderHistoryTab()}

            {/* Cancel Subscription Dialog */}
            <Dialog
              open={this.state.cancelDialogOpen}
              onClose={() => this.setState({ cancelDialogOpen: false })}
              maxWidth="sm"
            >
              <DialogTitle>{intl.formatMessage({ id: 'subscription.cancel.title' })}</DialogTitle>
              <DialogContent>
                <Typography variant="body1">
                  {intl.formatMessage({ id: 'subscription.cancel.confirm.message' })}
                </Typography>
                <Typography variant="body2" color="textSecondary" style={{ marginTop: 8 }}>
                  {intl.formatMessage({ id: 'subscription.cancel.period.end.info' })}
                </Typography>
              </DialogContent>
              <DialogActions>
                <Button onClick={() => this.setState({ cancelDialogOpen: false })} color="primary">
                  {intl.formatMessage({ id: 'subscription.keep.subscription' })}
                </Button>
                <Button
                  onClick={this.handleCancelSubscription}
                  color="error"
                  variant="contained"
                  disabled={this.state.canceling}
                >
                  {this.state.canceling ? <CircularProgress size={24} /> : intl.formatMessage({ id: 'subscription.confirm.cancel' })}
                </Button>
              </DialogActions>
            </Dialog>

            {/* Delete Payment Method Dialog */}
            <Dialog
              open={this.state.deleteDialogOpen}
              onClose={() => this.setState({ deleteDialogOpen: false })}
            >
              <DialogTitle>{intl.formatMessage({ id: 'subscription.remove.card.title' })}</DialogTitle>
              <DialogContent>
                <Typography>{intl.formatMessage({ id: 'subscription.remove.card.confirm' })}</Typography>
              </DialogContent>
              <DialogActions>
                <Button onClick={() => this.setState({ deleteDialogOpen: false })}>{intl.formatMessage({ id: 'cancel' })}</Button>
                <Button onClick={this.handleDeleteConfirm} color="error" variant="contained">
                  {intl.formatMessage({ id: 'subscription.remove' })}
                </Button>
              </DialogActions>
            </Dialog>

            {/* Stripe Card Form Dialog */}
            <StripeCardFormDialog
              open={this.state.addCardDialogOpen}
              onClose={() => this.setState({ addCardDialogOpen: false, clientSecret: null })}
              clientSecret={this.state.clientSecret}
              onSuccess={this.handleCardAdded}
              onError={(msg) => this.showError(msg)}
            />

            {/* Plan Selection Wizard (Assinar Agora) */}
            {(() => {
              const { subscribeStep, subscribeSelectedProductIds, subscribeProductSelections, subscribeProducts,
                subscribeAvailablePlans, subscribeAvailablePeriodicities } = this.state
              const getAppName = (appId) => { const p = subscribeProducts.find(x => (x.id ?? x.applicationid ?? x.applicationId) === appId); return p ? (p.name ?? p.applicationname ?? p.applicationName) : `App ${appId}` }
              const allPlansSelected = subscribeSelectedProductIds.length > 0 && subscribeSelectedProductIds.every(id => subscribeProductSelections[id]?.planId)
              const allPerSelected = subscribeSelectedProductIds.length > 0 && subscribeSelectedProductIds.every(id => subscribeProductSelections[id]?.ppId)
              // Total geral NO PERIODO DE COBRANCA (= soma de plan_value × quantity).
              // plan_value ja embute a periodicidade: anual = ppm × 12, trimestral = ppm × 3.
              // Cliente ajustou qtd no passo 3; aqui refletimos o impacto real no preco final.
              const totalValue = subscribeSelectedProductIds.reduce((sum, id) => {
                const s = subscribeProductSelections[id] || {}
                const q = Number(s.quantity) || 1
                const periodUnit = Number(s.planValue) || Number(s.value) || 0
                return sum + periodUnit * q
              }, 0)
              // MRR equivalente: total mensal recorrente (so plan_value_per_month × quantity).
              // Mostrado como sub-info — facilita comparacao quando periodicidade nao eh mensal.
              const totalMonthlyEquivalent = subscribeSelectedProductIds.reduce((sum, id) => {
                const s = subscribeProductSelections[id] || {}
                const q = Number(s.quantity) || 1
                return sum + (Number(s.value) || 0) * q
              }, 0)
              // Label dinamico da periodicidade. Se todos os produtos compartilham mesma
              // periodicidade, label fica especifico ("Total anual"); senao, generico ("Total").
              const uniquePeriodicities = [...new Set(
                subscribeSelectedProductIds
                  .map(id => (subscribeProductSelections[id]?.ppName || '').toLowerCase())
                  .filter(n => n)
              )]
              const totalLabel = uniquePeriodicities.length === 1
                ? `Total ${uniquePeriodicities[0]}`
                : 'Total no período'
              const sub = this.state.subscription || {}
              const gwType = sub.paymentgatewaytype ?? sub.paymentGatewayType ?? ''
              const isManualGateway = gwType === 'manual'
              const paymentStep = isManualGateway ? -1 : 3
              const summaryStep = isManualGateway ? 3 : 4
              const lastStep = summaryStep
              return (
              <Dialog
                open={this.state.planSelectDialogOpen}
                onClose={() => this.setState({ planSelectDialogOpen: false })}
                maxWidth="md"
                fullWidth
                PaperProps={{
                  sx: {
                    borderRadius: '16px',
                    overflow: 'hidden',
                    maxHeight: '90vh',
                    // flex column garante que DialogContent receba o espaco restante
                    // e role corretamente quando passa do tamanho do Paper.
                    display: 'flex',
                    flexDirection: 'column',
                  }
                }}
              >
                <div style={{ flex: '0 0 auto', background: 'linear-gradient(135deg, #8BC34A 0%, #689F38 100%)', padding: '24px 32px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div>
                    <Typography variant="h5" style={{ color: '#fff', fontWeight: 700 }}>{intl.formatMessage({ id: 'subscription.select.plan.title' })}</Typography>
                    <Typography variant="body2" style={{ color: 'rgba(255,255,255,0.85)', marginTop: 4 }}>{intl.formatMessage({ id: 'subscription.select.plan.description' })}</Typography>
                  </div>
                  <IconButton onClick={() => this.setState({ planSelectDialogOpen: false })} style={{ color: 'rgba(255,255,255,0.8)' }}><CancelIcon /></IconButton>
                </div>
                {/* Stepper */}
                <div style={{ flex: '0 0 auto', display: 'flex', justifyContent: 'center', gap: 16, padding: '20px 32px 0', backgroundColor: '#fafafa' }}>
                  {(isManualGateway ? ['Produtos', 'Planos', 'Periodicidade', 'Resumo'] : ['Produtos', 'Planos', 'Periodicidade', 'Pagamento', 'Resumo']).map((label, idx) => (
                    <div key={idx} style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                      <div style={{ width: 32, height: 32, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: subscribeStep >= idx ? '#8BC34A' : '#e0e0e0', color: '#fff', fontWeight: 700, fontSize: 14, transition: 'all 0.3s' }}>{idx + 1}</div>
                      <Typography variant="body2" style={{ fontWeight: subscribeStep === idx ? 700 : 400, color: subscribeStep === idx ? '#33691e' : '#999', transition: 'all 0.3s' }}>{label}</Typography>
                      {idx < (isManualGateway ? 3 : 4) && <div style={{ width: 32, height: 3, borderRadius: 2, backgroundColor: subscribeStep > idx ? '#8BC34A' : '#e0e0e0', transition: 'all 0.3s' }} />}
                    </div>
                  ))}
                </div>
                <Divider style={{ flex: '0 0 auto' }} />
                {/* DIV simples (nao DialogContent) — MUI v5 DialogContent tem CSS interno
                    que estava sobrescrevendo overflow/maxHeight nessa estrutura especifica.
                    Trocado por div puro: comportamento previsivel, sem conflito de specificity. */}
                <div style={{
                  maxHeight: 'calc(90vh - 240px)',
                  overflowY: 'auto',
                  padding: '24px 32px',
                  position: 'relative',
                  flex: '1 1 auto',
                  minHeight: 0
                }}>
                  {/* Overlay de processamento: cobre conteudo do step com spinner + mensagem
                      dinamica enquanto a conversao trial->paid roda no backend (Stripe sub +
                      InsertContractStep via outbox). Polling atualiza subscribeProvisioningMessage. */}
                  {this.state.subscribeProvisioningPhase && (
                    <div style={{
                      position: 'absolute', inset: 0, backgroundColor: 'rgba(255,255,255,0.96)',
                      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
                      zIndex: 10, gap: 16, padding: 24
                    }}>
                      <CircularProgress size={48} style={{ color: '#8BC34A' }} />
                      <Typography variant="h6" style={{ fontWeight: 700, color: '#33691e', textAlign: 'center' }}>
                        {this.state.subscribeProvisioningMessage || 'Processando...'}
                      </Typography>
                      <Typography variant="body2" color="textSecondary" style={{ textAlign: 'center', maxWidth: 400 }}>
                        Estamos finalizando sua assinatura. Isso pode levar alguns instantes — nao feche esta janela.
                      </Typography>
                    </div>
                  )}
                  {/* Step 0: Products */}
                  {subscribeStep === 0 && (
                    <div>
                      <Typography variant="h6" style={{ fontWeight: 600, marginBottom: 8, color: '#212121' }}>Selecione os produtos</Typography>
                      <Typography variant="body2" color="textSecondary" style={{ marginBottom: 20 }}>Seus produtos atuais já estão selecionados. Adicione ou remova conforme necessário.</Typography>
                      {this.state.subscribeProductsLoading ? <div style={{ textAlign: 'center', padding: 40 }}><CircularProgress size={32} style={{ color: '#8BC34A' }} /></div> : (
                        <Grid container spacing={2}>
                          {subscribeProducts.map(prod => {
                            const prodId = prod.id ?? prod.applicationid ?? prod.applicationId
                            const sel = subscribeSelectedProductIds.includes(prodId)
                            return (
                              <Grid item xs={12} sm={6} md={4} key={prodId}>
                                <Card elevation={sel ? 3 : 0} onClick={() => this.handleSubscribeToggleProduct(prodId)} style={{ cursor: 'pointer', borderRadius: 12, border: sel ? '2px solid #8BC34A' : '1px solid #e0e0e0', backgroundColor: sel ? '#f1f8e9' : '#fff', transition: 'all 0.2s ease', position: 'relative', height: '100%' }}>
                                  <CardContent style={{ textAlign: 'center', padding: '24px 16px' }}>
                                    {sel && <CheckCircleIcon style={{ color: '#8BC34A', fontSize: 24, position: 'absolute', right: 12, top: 12 }} />}
                                    <InventoryIcon style={{ fontSize: 40, color: sel ? '#689F38' : '#bdbdbd', marginBottom: 12 }} />
                                    <Typography variant="subtitle1" style={{ fontWeight: 700, color: sel ? '#33691e' : '#424242' }}>{prod.name ?? prod.applicationname ?? prod.applicationName}</Typography>
                                    <Typography variant="body2" color="textSecondary" style={{ marginTop: 4, minHeight: 40 }}>{prod.description ?? ''}</Typography>
                                  </CardContent>
                                </Card>
                              </Grid>
                            )
                          })}
                          {subscribeProducts.length === 0 && <Grid item xs={12}><Typography color="textSecondary" style={{ textAlign: 'center', padding: 32 }}>Nenhum produto disponível.</Typography></Grid>}
                        </Grid>
                      )}
                    </div>
                  )}
                  {/* Step 1: Plans per product */}
                  {subscribeStep === 1 && (
                    <div>
                      <Typography variant="h6" style={{ fontWeight: 600, marginBottom: 20, color: '#212121' }}>Selecione o plano para cada produto</Typography>
                      {this.state.loadingPlans ? <div style={{ textAlign: 'center', padding: 40 }}><CircularProgress size={32} style={{ color: '#8BC34A' }} /></div> : (
                        subscribeSelectedProductIds.map((appId, aIdx) => {
                          const plans = subscribeAvailablePlans[appId] || []
                          const selPlanId = subscribeProductSelections[appId]?.planId
                          return (
                            <div key={appId} style={{ marginBottom: aIdx < subscribeSelectedProductIds.length - 1 ? 28 : 0 }}>
                              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12 }}>
                                <InventoryIcon style={{ color: '#689F38', fontSize: 20 }} />
                                <Typography variant="subtitle1" style={{ fontWeight: 700, color: '#33691e' }}>{getAppName(appId)}</Typography>
                              </div>
                              <Grid container spacing={2}>
                                {plans.map(plan => {
                                  const sel = selPlanId === plan.id
                                  return (
                                    <Grid item xs={12} sm={6} md={4} key={plan.id}>
                                      <Card elevation={sel ? 3 : 0} onClick={() => this.handleSubscribeSelectPlan(appId, plan)} style={{ cursor: 'pointer', borderRadius: 12, border: sel ? '2px solid #277afe' : '1px solid #e0e0e0', backgroundColor: sel ? '#e3f2fd' : '#fff', transition: 'all 0.2s ease', position: 'relative' }}>
                                        <CardContent style={{ textAlign: 'center', padding: '20px 16px' }}>
                                          {sel && <CheckCircleIcon style={{ color: '#277afe', fontSize: 22, position: 'absolute', right: 10, top: 10 }} />}
                                          <Typography variant="subtitle1" style={{ fontWeight: 700, color: sel ? '#0d47a1' : '#424242' }}>{plan.name}</Typography>
                                          <Chip label={plan.isShared ? 'Compartilhado' : 'Dedicado'} size="small" style={{ marginTop: 8, backgroundColor: plan.isShared ? '#e0e0e0' : '#bbdefb', fontWeight: 500 }} />
                                        </CardContent>
                                      </Card>
                                    </Grid>
                                  )
                                })}
                                {plans.length === 0 && <Grid item xs={12}><Typography variant="body2" color="textSecondary" style={{ fontStyle: 'italic' }}>Nenhum plano disponível para este produto.</Typography></Grid>}
                              </Grid>
                              {aIdx < subscribeSelectedProductIds.length - 1 && <Divider style={{ marginTop: 20 }} />}
                            </div>
                          )
                        })
                      )}
                    </div>
                  )}
                  {/* Step 2: Periodicities per product */}
                  {subscribeStep === 2 && (
                    <div>
                      <Typography variant="h6" style={{ fontWeight: 600, marginBottom: 20, color: '#212121' }}>Selecione a periodicidade para cada produto</Typography>
                      {this.state.loadingPlans ? <div style={{ textAlign: 'center', padding: 40 }}><CircularProgress size={32} style={{ color: '#8BC34A' }} /></div> : (
                        subscribeSelectedProductIds.map((appId, aIdx) => {
                          const periodicities = subscribeAvailablePeriodicities[appId] || []
                          const selPpId = subscribeProductSelections[appId]?.ppId
                          return (
                            <div key={appId} style={{ marginBottom: aIdx < subscribeSelectedProductIds.length - 1 ? 28 : 0 }}>
                              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
                                <InventoryIcon style={{ color: '#689F38', fontSize: 20 }} />
                                <Typography variant="subtitle1" style={{ fontWeight: 700, color: '#33691e' }}>{getAppName(appId)}</Typography>
                              </div>
                              <Typography variant="body2" color="textSecondary" style={{ marginBottom: 12, marginLeft: 28 }}>Plano: <strong>{subscribeProductSelections[appId]?.planName}</strong></Typography>
                              <Grid container spacing={2}>
                                {periodicities.map(pp => {
                                  const sel = selPpId === pp.id
                                  const ppValue = pp.planvaluepermonth ?? pp.planValuePerMonth ?? pp.value ?? 0
                                  return (
                                    <Grid item xs={12} sm={6} md={4} key={pp.id}>
                                      <Card elevation={sel ? 3 : 0} onClick={() => this.handleSubscribeSelectPeriodicity(appId, pp)} style={{ cursor: 'pointer', borderRadius: 12, border: sel ? '2px solid #ff9800' : '1px solid #e0e0e0', backgroundColor: sel ? '#fff3e0' : '#fff', transition: 'all 0.2s ease', position: 'relative' }}>
                                        <CardContent style={{ textAlign: 'center', padding: '20px 16px' }}>
                                          {sel && <CheckCircleIcon style={{ color: '#ff9800', fontSize: 22, position: 'absolute', right: 10, top: 10 }} />}
                                          <Typography variant="subtitle1" style={{ fontWeight: 600 }}>{pp.periodicityname ?? pp.periodicityName}</Typography>
                                          <Typography variant="h5" style={{ color: '#ff9800', fontWeight: 800, marginTop: 8 }}>{this.formatCurrency(ppValue)}</Typography>
                                          <Typography variant="caption" color="textSecondary">/mês</Typography>
                                        </CardContent>
                                      </Card>
                                    </Grid>
                                  )
                                })}
                                {periodicities.length === 0 && <Grid item xs={12}><Typography variant="body2" color="textSecondary" style={{ fontStyle: 'italic' }}>Nenhuma periodicidade disponível.</Typography></Grid>}
                              </Grid>

                              {/* Stepper de quantidade — so aparece quando o usuario ja escolheu uma periodicidade.
                                  Bloco posicionado abaixo do Grid de periodicidades, sem competir por atencao.
                                  Subtotal calculado em tempo real (plan_value × quantity), exibido com hierarquia visual
                                  pra reforcar impacto do incremento. */}
                              {selPpId && (() => {
                                const cur = subscribeProductSelections[appId] || {}
                                const qty = Number(cur.quantity) || 1
                                const planValueUnit = Number(cur.planValue) || Number(cur.value) || 0
                                const monthlyUnit = Number(cur.value) || 0
                                const subtotal = planValueUnit * qty
                                const monthlyEquiv = monthlyUnit * qty
                                const MAX_QTY_OVERRIDE = 99
                                const planLimit = cur.userLimit && cur.userLimit > 0 ? cur.userLimit : 99
                                const maxQty = MAX_QTY_OVERRIDE ?? planLimit
                                const periodicityLabel = (cur.ppName || '').toLowerCase()
                                return (
                                  <div style={{
                                    marginTop: 16, padding: '16px 20px', borderRadius: 12,
                                    backgroundColor: '#fafafa', border: '1px solid #e0e0e0',
                                    display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 16, flexWrap: 'wrap'
                                  }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
                                      <Typography variant="body2" style={{ fontWeight: 600, color: '#424242' }}>
                                        Quantidade de licenças
                                      </Typography>
                                      <div style={{ display: 'flex', alignItems: 'center', gap: 0, border: '1px solid #d0d0d0', borderRadius: 8, backgroundColor: '#fff', overflow: 'hidden' }}>
                                        <IconButton
                                          size="small"
                                          onClick={() => this.handleQuantityChange(appId, -1)}
                                          disabled={qty <= 1}
                                          style={{ borderRadius: 0, padding: '6px 10px', color: qty <= 1 ? '#bdbdbd' : '#424242' }}
                                        >
                                          <RemoveIcon fontSize="small" />
                                        </IconButton>
                                        <div style={{ minWidth: 48, textAlign: 'center', padding: '4px 8px', borderLeft: '1px solid #e0e0e0', borderRight: '1px solid #e0e0e0' }}>
                                          <Typography variant="body1" style={{ fontWeight: 700, fontSize: 16 }}>{qty}</Typography>
                                        </div>
                                        <IconButton
                                          size="small"
                                          onClick={() => this.handleQuantityChange(appId, +1)}
                                          disabled={qty >= maxQty}
                                          style={{ borderRadius: 0, padding: '6px 10px', color: qty >= maxQty ? '#bdbdbd' : '#424242' }}
                                        >
                                          <AddIcon fontSize="small" />
                                        </IconButton>
                                      </div>
                                      <Typography variant="caption" color="textSecondary">
                                        {qty >= maxQty ? `máx. ${maxQty}` : `máx. ${maxQty} por plano`}
                                      </Typography>
                                    </div>
                                    <div style={{ textAlign: 'right' }}>
                                      <Typography variant="caption" color="textSecondary" style={{ display: 'block' }}>
                                        Subtotal {periodicityLabel}
                                      </Typography>
                                      <Typography variant="h6" style={{ color: '#277afe', fontWeight: 800 }}>
                                        {this.formatCurrency(subtotal)}
                                      </Typography>
                                      {monthlyEquiv !== subtotal && (
                                        <Typography variant="caption" color="textSecondary">
                                          equiv. {this.formatCurrency(monthlyEquiv)}/mês
                                        </Typography>
                                      )}
                                    </div>
                                  </div>
                                )
                              })()}

                              {aIdx < subscribeSelectedProductIds.length - 1 && <Divider style={{ marginTop: 20 }} />}
                            </div>
                          )
                        })
                      )}
                    </div>
                  )}
                  {/* Step: Payment Method (only for gateway) */}
                  {subscribeStep === paymentStep && paymentStep > 0 && (
                    <div>
                      <Typography variant="h6" style={{ fontWeight: 600, marginBottom: 20, color: '#212121' }}>Forma de pagamento</Typography>
                      {this.state.subscribePaymentMethodsLoading ? <div style={{ textAlign: 'center', padding: 40 }}><CircularProgress size={32} style={{ color: '#8BC34A' }} /></div> : (
                        <>
                          {this.state.subscribePaymentMethods.length === 0 ? (
                            <div style={{ textAlign: 'center', padding: 32 }}>
                              <CreditCardIcon style={{ fontSize: 48, color: '#bdbdbd', marginBottom: 12 }} />
                              <Typography variant="body1" style={{ fontWeight: 500, marginBottom: 8 }}>Nenhuma forma de pagamento cadastrada</Typography>
                              <Typography variant="body2" color="textSecondary" style={{ marginBottom: 16 }}>Adicione um cartao para prosseguir com a assinatura.</Typography>
                              <Button variant="contained" startIcon={<AddIcon />} onClick={this.handleSubscribeAddCard}
                                style={{ textTransform: 'none', fontWeight: 600, backgroundColor: '#8BC34A', color: '#fff' }}>
                                Adicionar Cartao
                              </Button>
                            </div>
                          ) : (
                            <>
                              <Typography variant="body2" color="textSecondary" style={{ marginBottom: 16 }}>Selecione o cartao que sera utilizado para o pagamento:</Typography>
                              <Grid container spacing={2}>
                                {this.state.subscribePaymentMethods.map(pm => {
                                  const pmId = pm.gatewaypaymentmethodid || pm.gatewayPaymentMethodId || pm.id || pm.Id
                                  const sel = this.state.subscribeSelectedPaymentMethodId === pmId
                                  const brand = (pm.cardbrand || pm.cardBrand || '').toUpperCase()
                                  const last4 = pm.cardlast4 || pm.cardLast4 || '****'
                                  const expMonth = pm.cardexpmonth || pm.cardExpMonth || '--'
                                  const expYear = pm.cardexpyear || pm.cardExpYear || '--'
                                  return (
                                    <Grid item xs={12} sm={6} key={pmId}>
                                      <Card elevation={sel ? 3 : 0} onClick={() => this.setState({ subscribeSelectedPaymentMethodId: pmId })}
                                        style={{ cursor: 'pointer', borderRadius: 12, border: sel ? '2px solid #8BC34A' : '1px solid #e0e0e0', backgroundColor: sel ? '#f1f8e9' : '#fff', transition: 'all 0.2s', position: 'relative' }}>
                                        <CardContent style={{ display: 'flex', alignItems: 'center', gap: 16, padding: '16px 20px' }}>
                                          {sel && <CheckCircleIcon style={{ color: '#8BC34A', fontSize: 22, position: 'absolute', right: 12, top: 12 }} />}
                                          <CreditCardIcon style={{ fontSize: 32, color: sel ? '#689F38' : '#9e9e9e' }} />
                                          <div>
                                            <Typography variant="subtitle1" style={{ fontWeight: 600 }}>{brand} **** {last4}</Typography>
                                            <Typography variant="body2" color="textSecondary">Validade: {expMonth}/{expYear}</Typography>
                                            {(pm.isdefault || pm.isDefault) && <Chip label="Padrao" size="small" style={{ marginTop: 4, backgroundColor: '#e0e0e0', fontSize: 11 }} />}
                                          </div>
                                        </CardContent>
                                      </Card>
                                    </Grid>
                                  )
                                })}
                              </Grid>
                              <div style={{ display: 'flex', gap: 12, marginTop: 16 }}>
                                <Button variant="text" startIcon={<AddIcon />} onClick={this.handleSubscribeAddCard}
                                  style={{ textTransform: 'none', color: '#689F38', fontWeight: 500 }}>
                                  Adicionar novo cartao
                                </Button>
                                <Button variant="text" startIcon={<RefreshIcon />} onClick={this.handleSubscribeLoadPaymentMethods}
                                  style={{ textTransform: 'none', color: '#757575', fontWeight: 500 }}>
                                  Sincronizar
                                </Button>
                              </div>
                            </>
                          )}
                          {this.state.subscribeAddCardOpen && this.state.subscribeAddCardSecret && (
                            <StripeCardFormDialog
                              open={this.state.subscribeAddCardOpen}
                              clientSecret={this.state.subscribeAddCardSecret}
                              onClose={() => this.setState({ subscribeAddCardOpen: false })}
                              onSuccess={this.handleSubscribeCardAdded}
                            />
                          )}
                        </>
                      )}
                    </div>
                  )}
                  {/* Step: Summary */}
                  {subscribeStep === summaryStep && (
                    <div>
                      <Typography variant="h6" style={{ fontWeight: 600, marginBottom: 20, color: '#212121' }}>Resumo da sua assinatura</Typography>
                      <TableContainer component={Paper} elevation={0} style={{ borderRadius: 12, border: '1px solid #e0e0e0' }}>
                        <Table>
                          <TableHead>
                            <TableRow style={{ backgroundColor: '#f5f7fa' }}>
                              <TableCell style={{ fontWeight: 700, color: '#424242' }}>Produto</TableCell>
                              <TableCell style={{ fontWeight: 700, color: '#424242' }}>Plano</TableCell>
                              <TableCell style={{ fontWeight: 700, color: '#424242' }}>Tipo</TableCell>
                              <TableCell style={{ fontWeight: 700, color: '#424242' }}>Periodicidade</TableCell>
                              <TableCell align="center" style={{ fontWeight: 700, color: '#424242' }}>Qtd</TableCell>
                              <TableCell align="right" style={{ fontWeight: 700, color: '#424242' }}>Valor/mês</TableCell>
                              <TableCell align="right" style={{ fontWeight: 700, color: '#424242' }}>Subtotal</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {subscribeSelectedProductIds.map(appId => {
                              const sel = subscribeProductSelections[appId] || {}
                              const qty = Number(sel.quantity) || 1
                              const monthlyUnit = Number(sel.value) || 0
                              const periodUnit = Number(sel.planValue) || monthlyUnit
                              const lineTotal = periodUnit * qty
                              return (
                                <TableRow key={appId} hover>
                                  <TableCell><strong>{getAppName(appId)}</strong></TableCell>
                                  <TableCell>{sel.planName || '-'}</TableCell>
                                  <TableCell><Chip label={sel.isShared ? 'Compartilhado' : 'Dedicado'} size="small" style={{ backgroundColor: sel.isShared ? '#e0e0e0' : '#bbdefb', fontWeight: 500, fontSize: 12 }} /></TableCell>
                                  <TableCell>{sel.ppName || '-'}</TableCell>
                                  <TableCell align="center">{qty}</TableCell>
                                  <TableCell align="right" style={{ fontWeight: 600, color: '#ff9800' }}>{this.formatCurrency(monthlyUnit)}</TableCell>
                                  <TableCell align="right" style={{ fontWeight: 700, color: '#277afe' }}>{this.formatCurrency(lineTotal)}</TableCell>
                                </TableRow>
                              )
                            })}
                          </TableBody>
                        </Table>
                      </TableContainer>
                      {/* Detalhe do calculo + total geral. Transparencia pro cliente entender
                          de onde sai o valor antes de confirmar pagamento. */}
                      <div style={{ marginTop: 20, padding: '20px 24px', backgroundColor: '#f5f7fa', borderRadius: 12, border: '1px solid #e0e0e0' }}>
                        <Typography variant="caption" style={{ fontWeight: 700, color: '#9e9e9e', textTransform: 'uppercase', letterSpacing: 1, marginBottom: 10, display: 'block' }}>
                          Detalhe do cálculo
                        </Typography>
                        {subscribeSelectedProductIds.map(appId => {
                          const sel = subscribeProductSelections[appId] || {}
                          const qty = Number(sel.quantity) || 1
                          const periodUnit = Number(sel.planValue) || Number(sel.value) || 0
                          const lineTotal = periodUnit * qty
                          return (
                            <div key={appId} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '4px 0', fontSize: 14, color: '#616161' }}>
                              <span><strong>{getAppName(appId)}</strong> ({sel.ppName || '-'}): {qty} × {this.formatCurrency(periodUnit)}</span>
                              <span style={{ fontWeight: 600, color: '#424242' }}>{this.formatCurrency(lineTotal)}</span>
                            </div>
                          )
                        })}
                        <Divider style={{ margin: '12px 0' }} />
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                          <Typography variant="h6" style={{ fontWeight: 600, color: '#424242' }}>{totalLabel}:</Typography>
                          <Typography variant="h4" style={{ fontWeight: 800, color: '#277afe' }}>{this.formatCurrency(totalValue)}</Typography>
                        </div>
                        {totalMonthlyEquivalent !== totalValue && (
                          <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 4 }}>
                            <Typography variant="caption" color="textSecondary">
                              Equivalente mensal (MRR): {this.formatCurrency(totalMonthlyEquivalent)}/mês
                            </Typography>
                          </div>
                        )}
                      </div>
                      {(() => {
                        const pm = this.state.subscribePaymentMethods.find(m => (m.gatewaypaymentmethodid || m.gatewayPaymentMethodId || m.id) === this.state.subscribeSelectedPaymentMethodId)
                        return pm ? (
                          <div style={{ marginTop: 16, display: 'flex', alignItems: 'center', gap: 12, padding: '12px 20px', backgroundColor: '#f5f7fa', borderRadius: 8, border: '1px solid #e0e0e0' }}>
                            <CreditCardIcon style={{ color: '#689F38', fontSize: 24 }} />
                            <div>
                              <Typography variant="body2" style={{ fontWeight: 600 }}>{(pm.cardbrand || pm.cardBrand || '').toUpperCase()} **** {pm.cardlast4 || pm.cardLast4}</Typography>
                              <Typography variant="caption" color="textSecondary">Validade: {pm.cardexpmonth || pm.cardExpMonth}/{pm.cardexpyear || pm.cardExpYear}</Typography>
                            </div>
                          </div>
                        ) : null
                      })()}
                      <div style={{ marginTop: 20, padding: '16px 20px', backgroundColor: '#e8f5e9', borderRadius: 8, border: '1px solid #c8e6c9' }}>
                        <div style={{ display: 'flex', alignItems: 'flex-start', gap: 8 }}>
                          <InfoIcon style={{ color: '#2e7d32', fontSize: 20, marginTop: 2 }} />
                          <Typography variant="body2" style={{ color: '#2e7d32' }}>
                            {isManualGateway
                              ? 'Ao confirmar, sua assinatura sera ativada. O faturamento sera realizado manualmente pela equipe comercial.'
                              : 'Ao confirmar, o pagamento sera processado automaticamente no cartao selecionado. Sua assinatura sera ativada imediatamente.'
                            }
                            {Object.values(subscribeProductSelections).some(s => s.isShared === false) && ' A infraestrutura dedicada será provisionada automaticamente.'}
                          </Typography>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                {/* Footer */}
                <div style={{ flex: '0 0 auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px 32px', backgroundColor: '#fafafa', borderTop: '1px solid #e0e0e0' }}>
                  <div>
                    {subscribeStep === summaryStep && <Typography variant="body2" color="textSecondary">{subscribeSelectedProductIds.length} produto{subscribeSelectedProductIds.length !== 1 ? 's' : ''} selecionado{subscribeSelectedProductIds.length !== 1 ? 's' : ''}</Typography>}
                  </div>
                  <div style={{ display: 'flex', gap: 12 }}>
                    <Button onClick={() => this.setState({ planSelectDialogOpen: false })} style={{ textTransform: 'none', fontWeight: 500, color: '#757575' }}>{intl.formatMessage({ id: 'cancel' })}</Button>
                    {subscribeStep > 0 && <Button onClick={() => this.setState(prev => ({ subscribeStep: prev.subscribeStep - 1 }))} variant="outlined" style={{ textTransform: 'none', fontWeight: 500, borderColor: '#bdbdbd', color: '#616161' }}>Voltar</Button>}
                    {subscribeStep < lastStep && (
                      <Button variant="contained" disabled={
                        (subscribeStep === 0 && subscribeSelectedProductIds.length === 0) ||
                        (subscribeStep === 1 && !allPlansSelected) ||
                        (subscribeStep === 2 && !allPerSelected) ||
                        (subscribeStep === paymentStep && !isManualGateway && !this.state.subscribeSelectedPaymentMethodId)
                      }
                        onClick={this.handleSubscribeNext} style={{ textTransform: 'none', fontWeight: 700, borderRadius: 8, backgroundColor: '#8BC34A', color: '#fff', padding: '8px 28px' }}>
                        Próximo
                      </Button>
                    )}
                    {subscribeStep === lastStep && (
                      <Button variant="contained" onClick={() => this.setState({ subscribeConfirmOpen: true })} disabled={this.state.checkoutLoading}
                        style={{ textTransform: 'none', fontWeight: 700, borderRadius: 8, backgroundColor: '#8BC34A', color: '#fff', padding: '8px 28px' }}>
                        {this.state.checkoutLoading ? <CircularProgress size={22} style={{ color: '#fff' }} /> : 'Assinar Agora'}
                      </Button>
                    )}
                  </div>
                </div>
              </Dialog>
              )
            })()}

            {/* Confirm Subscribe Dialog */}
            <Dialog open={this.state.subscribeConfirmOpen} onClose={() => this.setState({ subscribeConfirmOpen: false })} maxWidth="xs" fullWidth PaperProps={{ sx: { borderRadius: '12px' } }}>
              <div style={{ padding: '24px', textAlign: 'center' }}>
                <ShoppingCartIcon style={{ fontSize: 48, color: '#8BC34A', marginBottom: 12 }} />
                <Typography variant="h6" style={{ fontWeight: 700, marginBottom: 8 }}>Confirmar Assinatura</Typography>
                <Typography variant="body2" color="textSecondary" style={{ marginBottom: 20 }}>
                  {(this.state.subscription?.paymentgatewaytype ?? this.state.subscription?.paymentGatewayType) === 'manual'
                    ? 'Sua assinatura sera ativada com faturamento manual. Deseja prosseguir?'
                    : 'O pagamento sera processado na forma de pagamento cadastrada. Deseja prosseguir?'
                  }
                </Typography>
                <div style={{ display: 'flex', justifyContent: 'center', gap: 12 }}>
                  <Button onClick={() => this.setState({ subscribeConfirmOpen: false })} variant="outlined" style={{ textTransform: 'none', fontWeight: 500, borderColor: '#bdbdbd', color: '#616161' }}>{intl.formatMessage({ id: 'cancel' })}</Button>
                  <Button variant="contained" onClick={this.handleSubscribeConfirm} style={{ textTransform: 'none', fontWeight: 700, backgroundColor: '#8BC34A', color: '#fff', padding: '8px 24px' }}>
                    Sim, Assinar
                  </Button>
                </div>
              </div>
            </Dialog>

            {/* Change Plan Wizard Dialog */}
            <Dialog
              open={this.state.changePlanDialogOpen}
              onClose={() => this.setState({ changePlanDialogOpen: false })}
              maxWidth="sm"
              fullWidth
              PaperProps={{ sx: { maxHeight: '90vh' } }}
            >
              <DialogTitle style={{ backgroundColor: '#277afe', color: '#fff' }}>
                <CompareArrowsIcon style={{ verticalAlign: 'middle', marginRight: 8 }} />
                {intl.formatMessage({ id: 'subscription.change.plan' })}
              </DialogTitle>
              <DialogContent style={{ paddingTop: 20, overflowY: 'auto', maxHeight: '70vh' }}>
                <Stepper activeStep={this.state.changePlanStep} style={{ marginBottom: 24 }}>
                  <Step><StepLabel>{intl.formatMessage({ id: 'subscription.step.select.product' })}</StepLabel></Step>
                  <Step><StepLabel>{intl.formatMessage({ id: 'subscription.step.select.plan' })}</StepLabel></Step>
                  <Step><StepLabel>{intl.formatMessage({ id: 'subscription.step.confirm' })}</StepLabel></Step>
                </Stepper>

                {/* Step 0 — Select product */}
                {this.state.changePlanStep === 0 && (
                  <>
                    <Typography variant="body2" color="textSecondary" style={{ marginBottom: 16 }}>
                      {intl.formatMessage({ id: 'subscription.change.plan.select.product' })}
                    </Typography>
                    {this.state.contractProducts.map((cp, idx) => (
                      <Card key={idx} elevation={1} style={{ marginBottom: 12, cursor: 'pointer', border: '1px solid #e0e0e0', transition: 'all 0.2s' }}
                        onClick={() => this.handleChangePlanSelectProduct(cp)}
                      >
                        <CardContent style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 16px' }}>
                          <div>
                            <Typography variant="subtitle1" style={{ fontWeight: 600 }}>{cp.applicationname ?? cp.applicationName ?? '-'}</Typography>
                            <Typography variant="body2" color="textSecondary">{cp.planname ?? cp.planName ?? '-'} — {cp.periodicityname ?? cp.periodicityName ?? '-'}</Typography>
                          </div>
                          <Typography variant="h6" style={{ fontWeight: 700 }}>{this.formatCurrency(cp.planvaluepermonth ?? cp.planValuePerMonth)}</Typography>
                        </CardContent>
                      </Card>
                    ))}
                    {this.state.changePlanLoading && <div style={{ textAlign: 'center', padding: 16 }}><CircularProgress size={28} /></div>}
                  </>
                )}

                {/* Step 1 — Select plan + periodicity */}
                {this.state.changePlanStep === 1 && (
                  <>
                    {this.state.changePlanLoading && <div style={{ textAlign: 'center', padding: 24 }}><CircularProgress size={28} /></div>}
                    {!this.state.changePlanLoading && (
                      <>
                        <Typography variant="body2" color="textSecondary" style={{ marginBottom: 12 }}>
                          {intl.formatMessage({ id: 'subscription.change.plan.select.new' })} <strong>{this.state.changePlanSelectedProduct?.applicationname ?? this.state.changePlanSelectedProduct?.applicationName ?? ''}</strong>
                        </Typography>

                        {/* Plan selection */}
                        <Typography variant="caption" style={{ fontWeight: 700, color: '#757575', textTransform: 'uppercase', letterSpacing: 1 }}>
                          {intl.formatMessage({ id: 'subscription.plan.name' })}
                        </Typography>
                        <div style={{ display: 'flex', gap: 12, marginTop: 8, marginBottom: 20, flexWrap: 'wrap' }}>
                          {this.state.changePlanPlans.map((plan, idx) => {
                            const isSelected = this.state.changePlanSelectedPlanId === plan.id
                            return (
                              <Card key={idx} elevation={isSelected ? 6 : 1}
                                style={{
                                  flex: '1 1 0', minWidth: 120, cursor: 'pointer',
                                  border: isSelected ? '2px solid #8BC34A' : '1px solid #e0e0e0',
                                  backgroundColor: isSelected ? '#f1f8e9' : '#fff',
                                  transition: 'all 0.2s'
                                }}
                                onClick={() => this.handleChangePlanSelectPlan(plan)}
                              >
                                <CardContent style={{ textAlign: 'center', padding: '16px 12px', position: 'relative' }}>
                                  {isSelected && <CheckCircleIcon style={{ position: 'absolute', top: 8, right: 8, fontSize: 20, color: '#8BC34A' }} />}
                                  <Typography variant="subtitle1" style={{ fontWeight: 600, color: isSelected ? '#558B2F' : '#212121' }}>{plan.name}</Typography>
                                </CardContent>
                              </Card>
                            )
                          })}
                        </div>

                        {/* Periodicity selection */}
                        {this.state.changePlanPeriodicities.length > 0 && (
                          <>
                            <Typography variant="caption" style={{ fontWeight: 700, color: '#757575', textTransform: 'uppercase', letterSpacing: 1 }}>
                              {intl.formatMessage({ id: 'subscription.periodicity' })}
                            </Typography>
                            <div style={{ display: 'flex', gap: 12, marginTop: 8, flexWrap: 'wrap' }}>
                              {this.state.changePlanPeriodicities.map((pp, idx) => {
                                const ppId = pp.id || pp.Id
                                const periodicityName = pp.periodicityname || pp.periodicityName || pp.PeriodicityName || '-'
                                // Mostra plan_value (valor total da periodicidade, ex.: anual = 12×mensal).
                                // Fallback pra plan_value_per_month quando o plano só tem mensal preenchido.
                                const value = pp.planvalue ?? pp.planValue ?? pp.PlanValue ?? pp.value ?? pp.Value ?? pp.planvaluepermonth ?? pp.planValuePerMonth ?? 0
                                const isSelected = this.state.changePlanSelectedNewId === ppId
                                return (
                                  <Card key={idx} elevation={isSelected ? 6 : 1}
                                    style={{
                                      flex: '1 1 0', minWidth: 140, cursor: 'pointer',
                                      border: isSelected ? '2px solid #8BC34A' : '1px solid #e0e0e0',
                                      backgroundColor: isSelected ? '#f1f8e9' : '#fff',
                                      transition: 'all 0.2s'
                                    }}
                                    onClick={() => this.setState({ changePlanSelectedNewId: ppId })}
                                  >
                                    <CardContent style={{ textAlign: 'center', padding: '16px 12px', position: 'relative' }}>
                                      {isSelected && <CheckCircleIcon style={{ position: 'absolute', top: 8, right: 8, fontSize: 20, color: '#8BC34A' }} />}
                                      <Typography variant="subtitle2" style={{ fontWeight: 600, color: isSelected ? '#558B2F' : '#212121' }}>{periodicityName}</Typography>
                                      <Typography variant="h6" style={{ fontWeight: 700, color: isSelected ? '#558B2F' : '#212121', marginTop: 4 }}>{this.formatCurrency(value)}</Typography>
                                    </CardContent>
                                  </Card>
                                )
                              })}
                            </div>
                          </>
                        )}

                        {this.state.changePlanPlans.length === 0 && (
                          <Typography variant="body2" color="textSecondary" style={{ textAlign: 'center', padding: 24 }}>
                            {intl.formatMessage({ id: 'subscription.no.other.plans' })}
                          </Typography>
                        )}
                      </>
                    )}
                  </>
                )}

                {/* Step 2 — Confirm */}
                {this.state.changePlanStep === 2 && this.state.changePlanLoading && (
                  <div style={{ textAlign: 'center', padding: 32 }}>
                    <CircularProgress size={48} style={{ marginBottom: 16 }} />
                    <Typography variant="body1" color="textSecondary">{intl.formatMessage({ id: 'loading' })}</Typography>
                  </div>
                )}
                {this.state.changePlanStep === 2 && !this.state.changePlanLoading && (
                  <Card elevation={0} style={{ backgroundColor: '#e3f2fd', border: '1px solid #90caf9' }}>
                    <CardContent>
                      <Typography variant="subtitle2" style={{ color: '#1565c0', marginBottom: 12 }}>
                        {intl.formatMessage({ id: 'subscription.change.plan.preview' })}
                      </Typography>
                      <Grid container spacing={2}>
                        <Grid item xs={6}>
                          <Typography variant="caption" color="textSecondary">{intl.formatMessage({ id: 'subscription.current.plan' })}</Typography>
                          <Typography variant="body2" style={{ fontWeight: 600 }}>
                            {this.state.changePlanSelectedProduct?.planname ?? this.state.changePlanSelectedProduct?.planName ?? '-'}
                          </Typography>
                          <Typography variant="body2" color="textSecondary">
                            {this.state.changePlanSelectedProduct?.periodicityname ?? this.state.changePlanSelectedProduct?.periodicityName ?? ''}
                          </Typography>
                          <Typography variant="body2">
                            {/* Plano atual: mostra plan_value (total da periodicidade). */}
                            {this.formatCurrency(
                              this.state.changePlanSelectedProduct?.planvalue
                              ?? this.state.changePlanSelectedProduct?.planValue
                              ?? this.state.changePlanSelectedProduct?.planvaluepermonth
                              ?? this.state.changePlanSelectedProduct?.planValuePerMonth
                            )}
                          </Typography>
                        </Grid>
                        <Grid item xs={6}>
                          <Typography variant="caption" color="textSecondary">{intl.formatMessage({ id: 'subscription.new.plan' })}</Typography>
                          {(() => {
                            const newPp = this.state.changePlanAllPeriodicities.find(p => (p.id || p.Id) === this.state.changePlanSelectedNewId)
                            const selectedPlan = this.state.changePlanPlans.find(p => p.id === this.state.changePlanSelectedPlanId)
                            return newPp ? (
                              <>
                                <Typography variant="body2" style={{ fontWeight: 600 }}>{selectedPlan?.name ?? '-'}</Typography>
                                <Typography variant="body2" color="textSecondary">{newPp.periodicityname || newPp.periodicityName || newPp.PeriodicityName || ''}</Typography>
                                <Typography variant="body2">{this.formatCurrency(
                                  newPp.planvalue ?? newPp.planValue ?? newPp.PlanValue
                                  ?? newPp.value ?? newPp.Value
                                  ?? newPp.planvaluepermonth ?? newPp.planValuePerMonth ?? 0
                                )}</Typography>
                              </>
                            ) : <Typography variant="body2">-</Typography>
                          })()}
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                )}
              </DialogContent>
              <DialogActions style={{ padding: '12px 24px' }}>
                {this.state.changePlanStep > 0 && (
                  <Button onClick={() => this.setState(prev => ({ changePlanStep: prev.changePlanStep - 1 }))} style={{ textTransform: 'none' }}>
                    {intl.formatMessage({ id: 'back' })}
                  </Button>
                )}
                <div style={{ flex: 1 }} />
                <Button onClick={() => this.setState({ changePlanDialogOpen: false })} style={{ textTransform: 'none' }}>
                  {intl.formatMessage({ id: 'cancel' })}
                </Button>
                {this.state.changePlanStep === 1 && this.state.changePlanSelectedNewId > 0 && (
                  <Button
                    variant="contained"
                    onClick={() => this.setState({ changePlanStep: 2 })}
                    style={{ backgroundColor: '#277afe', color: '#fff', textTransform: 'none', fontWeight: 600 }}
                  >
                    {intl.formatMessage({ id: 'subscription.continue' })}
                  </Button>
                )}
                {this.state.changePlanStep === 2 && (
                  <Button
                    variant="contained"
                    onClick={this.handleConfirmChangePlan}
                    disabled={this.state.changePlanLoading}
                    style={{ backgroundColor: '#277afe', color: '#fff', textTransform: 'none', fontWeight: 600 }}
                  >
                    {this.state.changePlanLoading ? <CircularProgress size={24} style={{ color: '#fff' }} /> : intl.formatMessage({ id: 'subscription.confirm.change.plan' })}
                  </Button>
                )}
              </DialogActions>
            </Dialog>

            {/* Cancel Products Dialog */}
            <Dialog
              open={this.state.cancelProductsDialogOpen}
              onClose={() => this.setState({ cancelProductsDialogOpen: false })}
              maxWidth="sm"
              fullWidth
            >
              <DialogTitle style={{ backgroundColor: '#f44336', color: '#fff' }}>
                <CancelIcon style={{ verticalAlign: 'middle', marginRight: 8 }} />
                {intl.formatMessage({ id: 'subscription.cancel.subscription' })}
              </DialogTitle>
              <DialogContent style={{ paddingTop: 20 }}>
                {this.state.cancelProductsStep === 0 && (
                  <>
                    <Typography variant="body2" color="textSecondary" style={{ marginBottom: 16 }}>
                      {intl.formatMessage({ id: 'subscription.cancel.select.products' })}
                    </Typography>
                    {this.state.contractProducts.map((cp, idx) => {
                      const ppId = cp.planperiodicityid ?? cp.planPeriodicityId ?? cp.id ?? 0
                      const checked = this.state.cancelProductsSelected.includes(ppId)
                      return (
                        <Card key={idx} elevation={checked ? 3 : 1}
                          style={{ marginBottom: 12, border: checked ? '2px solid #f44336' : '1px solid #e0e0e0', cursor: 'pointer', transition: 'all 0.2s' }}
                          onClick={() => this.handleToggleCancelProduct(ppId)}
                        >
                          <CardContent style={{ display: 'flex', alignItems: 'center', padding: '8px 16px' }}>
                            <Checkbox checked={checked} color="error" style={{ marginRight: 8 }} />
                            <div style={{ flex: 1 }}>
                              <Typography variant="subtitle2" style={{ fontWeight: 600 }}>{cp.applicationname ?? cp.applicationName ?? '-'}</Typography>
                              <Typography variant="caption" color="textSecondary">{cp.planname ?? cp.planName ?? '-'} — {cp.periodicityname ?? cp.periodicityName ?? ''} — {this.formatCurrency(cp.planvaluepermonth ?? cp.planValuePerMonth)}</Typography>
                            </div>
                          </CardContent>
                        </Card>
                      )
                    })}
                    {this.state.cancelProductsSelected.length === this.state.contractProducts.length && this.state.contractProducts.length > 0 && (
                      <div style={{ padding: '12px 16px', backgroundColor: '#ffebee', border: '1px solid #ef9a9a', borderRadius: 4, marginTop: 8 }}>
                        <Typography variant="body2" style={{ color: '#c62828' }}>
                          <WarningIcon style={{ fontSize: 16, verticalAlign: 'middle', marginRight: 4 }} />
                          {intl.formatMessage({ id: 'subscription.cancel.all.warning' })}
                        </Typography>
                      </div>
                    )}
                  </>
                )}
                {this.state.cancelProductsStep === 1 && (
                  <div style={{ textAlign: 'center', padding: 16 }}>
                    {this.state.cancelProductsLoading ? (
                      <>
                        <CircularProgress size={48} style={{ marginBottom: 16 }} />
                        <Typography variant="body1" color="textSecondary">
                          {intl.formatMessage({ id: 'loading' })}
                        </Typography>
                      </>
                    ) : (
                      <>
                        <WarningIcon style={{ fontSize: 48, color: '#f44336', marginBottom: 8 }} />
                        <Typography variant="h6" style={{ fontWeight: 600, marginBottom: 8 }}>
                          {intl.formatMessage({ id: 'subscription.cancel.confirm.title' })}
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                          {this.state.cancelProductsSelected.length === this.state.contractProducts.length
                            ? intl.formatMessage({ id: 'subscription.cancel.all.confirm' })
                            : intl.formatMessage({ id: 'subscription.cancel.partial.confirm' }, { count: this.state.cancelProductsSelected.length })
                          }
                        </Typography>
                      </>
                    )}
                  </div>
                )}
              </DialogContent>
              <DialogActions style={{ padding: '12px 24px' }}>
                <Button onClick={() => this.setState({ cancelProductsDialogOpen: false })} style={{ textTransform: 'none' }}>
                  {intl.formatMessage({ id: 'subscription.keep.subscription' })}
                </Button>
                {this.state.cancelProductsStep === 0 && (
                  <Button
                    variant="contained" color="error"
                    disabled={this.state.cancelProductsSelected.length === 0}
                    onClick={() => this.setState({ cancelProductsStep: 1 })}
                    style={{ textTransform: 'none', fontWeight: 600 }}
                  >
                    {intl.formatMessage({ id: 'subscription.continue' })}
                  </Button>
                )}
                {this.state.cancelProductsStep === 1 && (
                  <Button
                    variant="contained" color="error"
                    disabled={this.state.cancelProductsLoading}
                    onClick={this.handleConfirmCancelProducts}
                    style={{ textTransform: 'none', fontWeight: 600 }}
                  >
                    {this.state.cancelProductsLoading ? <CircularProgress size={24} style={{ color: '#fff' }} /> : intl.formatMessage({ id: 'subscription.confirm.cancel' })}
                  </Button>
                )}
              </DialogActions>
            </Dialog>

            {/* Reactivate Subscription Dialog */}
            <Dialog
              open={this.state.reactivateDialogOpen}
              onClose={() => this.setState({ reactivateDialogOpen: false })}
              maxWidth="sm"
              fullWidth
            >
              <DialogTitle style={{ backgroundColor: '#4caf50', color: '#fff' }}>
                <RestoreIcon style={{ verticalAlign: 'middle', marginRight: 8 }} />
                {intl.formatMessage({ id: 'subscription.reactivate' })}
              </DialogTitle>
              <DialogContent style={{ paddingTop: 20 }}>
                {this.state.reactivateStep === 0 && (
                  <>
                    <Typography variant="body2" color="textSecondary" style={{ marginBottom: 16 }}>
                      {intl.formatMessage({ id: 'subscription.reactivate.select.products' })}
                    </Typography>
                    {this.state.reactivateCanceledProducts.map((cp, idx) => {
                      const ppId = cp.planperiodicityid ?? cp.planPeriodicityId ?? 0
                      const checked = this.state.reactivateSelected.includes(ppId)
                      return (
                        <Card key={idx} elevation={checked ? 3 : 1}
                          style={{ marginBottom: 12, border: checked ? '2px solid #4caf50' : '1px solid #e0e0e0', cursor: 'pointer', transition: 'all 0.2s' }}
                          onClick={() => this.handleToggleReactivateProduct(ppId)}
                        >
                          <CardContent style={{ display: 'flex', alignItems: 'center', padding: '8px 16px' }}>
                            <Checkbox checked={checked} color="success" style={{ marginRight: 8 }} />
                            <div style={{ flex: 1 }}>
                              <Typography variant="subtitle2" style={{ fontWeight: 600 }}>{cp.applicationname ?? cp.applicationName ?? '-'}</Typography>
                              <Typography variant="caption" color="textSecondary">{cp.planname ?? cp.planName ?? '-'} — {this.formatCurrency(cp.planvaluepermonth ?? cp.planValuePerMonth)}</Typography>
                            </div>
                          </CardContent>
                        </Card>
                      )
                    })}
                    {this.state.reactivateCanceledProducts.length === 0 && (
                      <Typography variant="body2" color="textSecondary" style={{ textAlign: 'center', padding: 24 }}>
                        {intl.formatMessage({ id: 'subscription.no.canceled.products' })}
                      </Typography>
                    )}
                  </>
                )}
                {this.state.reactivateStep === 1 && (
                  <div style={{ textAlign: 'center', padding: 16 }}>
                    <CheckCircleIcon style={{ fontSize: 48, color: '#4caf50', marginBottom: 8 }} />
                    <Typography variant="h6" style={{ fontWeight: 600, marginBottom: 8 }}>
                      {intl.formatMessage({ id: 'subscription.reactivate.confirm.title' })}
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                      {intl.formatMessage({ id: 'subscription.reactivate.confirm.message' }, { count: this.state.reactivateSelected.length })}
                    </Typography>
                  </div>
                )}
              </DialogContent>
              <DialogActions style={{ padding: '12px 24px' }}>
                <Button onClick={() => this.setState({ reactivateDialogOpen: false })} style={{ textTransform: 'none' }}>
                  {intl.formatMessage({ id: 'cancel' })}
                </Button>
                {this.state.reactivateStep === 0 && (
                  <Button variant="contained"
                    disabled={this.state.reactivateSelected.length === 0}
                    onClick={() => this.setState({ reactivateStep: 1 })}
                    style={{ backgroundColor: '#4caf50', color: '#fff', textTransform: 'none', fontWeight: 600 }}
                  >
                    {intl.formatMessage({ id: 'subscription.continue' })}
                  </Button>
                )}
                {this.state.reactivateStep === 1 && (
                  <Button variant="contained"
                    disabled={this.state.reactivateLoading}
                    onClick={this.handleConfirmReactivate}
                    style={{ backgroundColor: '#4caf50', color: '#fff', textTransform: 'none', fontWeight: 600 }}
                  >
                    {this.state.reactivateLoading ? <CircularProgress size={24} style={{ color: '#fff' }} /> : intl.formatMessage({ id: 'subscription.confirm.reactivate' })}
                  </Button>
                )}
              </DialogActions>
            </Dialog>

            {/* Credit Management Dialog */}
            <Dialog
              open={this.state.creditDialogOpen}
              onClose={() => this.setState({ creditDialogOpen: false })}
              maxWidth="sm"
              fullWidth
            >
              <DialogTitle style={{ backgroundColor: '#8BC34A', color: '#fff' }}>
                {intl.formatMessage({ id: 'subscription.credit.manage' })}
                {this.state.creditDialogBalance && (
                  <Typography variant="body2" style={{ color: 'rgba(255,255,255,0.9)' }}>
                    {this.state.creditDialogBalance.applicationname ?? this.state.creditDialogBalance.applicationName ?? ''}
                  </Typography>
                )}
              </DialogTitle>
              <DialogContent style={{ paddingTop: 20 }}>
                {this.state.creditDialogBalance && (
                  <>
                    {/* Current Balance */}
                    <div style={{ textAlign: 'center', padding: '16px 0', marginBottom: 16, backgroundColor: '#f1f8e9', borderRadius: 8 }}>
                      <Typography variant="caption" color="textSecondary">{intl.formatMessage({ id: 'subscription.credit.balance.label' })}</Typography>
                      <Typography variant="h4" style={{ fontWeight: 700, color: '#2e7d32' }}>
                        {this.formatCurrency(this.state.creditDialogBalance.currentbalance ?? this.state.creditDialogBalance.currentBalance ?? 0)}
                      </Typography>
                      <Grid container spacing={1} justifyContent="center" style={{ marginTop: 8 }}>
                        <Grid item>
                          <Typography variant="caption" color="textSecondary">
                            {intl.formatMessage({ id: 'subscription.credit.total.purchased' })}: <strong>{this.formatCurrency(this.state.creditDialogBalance.totalpurchased ?? this.state.creditDialogBalance.totalPurchased ?? 0)}</strong>
                          </Typography>
                        </Grid>
                        <Grid item>
                          <Typography variant="caption" color="textSecondary">
                            {intl.formatMessage({ id: 'subscription.credit.total.consumed' })}: <strong>{this.formatCurrency(this.state.creditDialogBalance.totalconsumed ?? this.state.creditDialogBalance.totalConsumed ?? 0)}</strong>
                          </Typography>
                        </Grid>
                      </Grid>
                    </div>

                    {/* Credit Info */}
                    <Grid container spacing={2} style={{ marginBottom: 16 }}>
                      <Grid item xs={12}>
                        <TextField label={intl.formatMessage({ id: 'subscription.credit.monthly.amount' })}
                          value={this.state.creditEditCreditAmountMonthly} fullWidth size="small" variant="outlined" disabled
                          InputProps={{ style: { backgroundColor: '#ebebeb', color: '#777' } }}
                        />
                      </Grid>
                    </Grid>

                    {/* Purchase Credits */}
                    <Typography variant="subtitle2" style={{ fontWeight: 600, marginBottom: 8 }}>
                      {intl.formatMessage({ id: 'subscription.credit.purchase' })}
                    </Typography>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 12, marginBottom: 20 }}>
                      <TextField
                        label={intl.formatMessage({ id: 'subscription.credit.purchase.amount' })}
                        type="number"
                        value={this.state.creditPurchaseAmount}
                        onChange={(e) => this.setState({ creditPurchaseAmount: e.target.value })}
                        size="small" variant="outlined" fullWidth
                        inputProps={{ step: '0.01', min: '0' }}
                      />
                      {this.state.creditPaymentMethods.length > 0 && (
                        <TextField
                          select
                          label={intl.formatMessage({ id: 'subscription.credit.payment.method' })}
                          value={this.state.creditSelectedPaymentMethodId}
                          onChange={(e) => this.setState({ creditSelectedPaymentMethodId: e.target.value })}
                          size="small" variant="outlined" fullWidth
                          SelectProps={{ native: true }}
                          InputLabelProps={{ shrink: true }}
                        >
                          <option value="">Selecione...</option>
                          {this.state.creditPaymentMethods.map(pm => (
                            <option key={pm.id} value={pm.id}>{pm.name}</option>
                          ))}
                        </TextField>
                      )}
                      <Button
                        variant="contained"
                        onClick={() => this.setState({ creditPurchaseConfirmOpen: true })}
                        disabled={this.state.creditPurchaseLoading || !this.state.creditPurchaseAmount || (this.state.creditPaymentMethods.length > 0 && !this.state.creditSelectedPaymentMethodId)}
                        style={{ backgroundColor: '#8BC34A', color: '#fff', textTransform: 'none', fontWeight: 600 }}
                      >
                        {this.state.creditPurchaseLoading ? <CircularProgress size={20} style={{ color: '#fff' }} /> : intl.formatMessage({ id: 'subscription.credit.buy' })}
                      </Button>
                    </div>

                    <Divider style={{ margin: '16px 0' }} />

                    {/* Settings */}
                    <Typography variant="subtitle2" style={{ fontWeight: 600, marginBottom: 12 }}>
                      {intl.formatMessage({ id: 'subscription.credit.settings' })}
                    </Typography>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          label={intl.formatMessage({ id: 'subscription.credit.alert.threshold' })}
                          type="number"
                          value={this.state.creditEditAlertThreshold}
                          onChange={(e) => this.setState({ creditEditAlertThreshold: e.target.value })}
                          fullWidth size="small" variant="outlined"
                          inputProps={{ step: '0.01', min: '0' }}
                          helperText={intl.formatMessage({ id: 'subscription.credit.alert.helper' })}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          select label={intl.formatMessage({ id: 'subscription.credit.auto.recharge' })}
                          value={this.state.creditEditAutoRechargeEnabled ? 'true' : 'false'}
                          onChange={(e) => this.setState({ creditEditAutoRechargeEnabled: e.target.value === 'true' })}
                          fullWidth size="small" variant="outlined"
                          SelectProps={{ native: true }} InputLabelProps={{ shrink: true }}
                        >
                          <option value="false">{intl.formatMessage({ id: 'no' })}</option>
                          <option value="true">{intl.formatMessage({ id: 'yes' })}</option>
                        </TextField>
                      </Grid>
                      {this.state.creditEditAutoRechargeEnabled && (
                        <>
                          <Grid item xs={12} sm={6}>
                            <TextField label={intl.formatMessage({ id: 'subscription.credit.recharge.amount' })}
                              type="number" value={this.state.creditEditAutoRechargeAmount}
                              onChange={(e) => this.setState({ creditEditAutoRechargeAmount: e.target.value })}
                              fullWidth size="small" variant="outlined" inputProps={{ step: '0.01', min: '0' }}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <TextField label={intl.formatMessage({ id: 'subscription.credit.recharge.trigger' })}
                              type="number" value={this.state.creditEditAutoRechargeTrigger}
                              onChange={(e) => this.setState({ creditEditAutoRechargeTrigger: e.target.value })}
                              fullWidth size="small" variant="outlined" inputProps={{ step: '0.01', min: '0' }}
                            />
                          </Grid>
                        </>
                      )}
                    </Grid>
                  </>
                )}
              </DialogContent>
              <DialogActions style={{ padding: '12px 24px' }}>
                <Button onClick={() => this.setState({ creditDialogOpen: false })} style={{ textTransform: 'none' }}>
                  {intl.formatMessage({ id: 'cancel' })}
                </Button>
                <Button
                  variant="contained"
                  onClick={this.handleSaveCreditSettings}
                  disabled={this.state.creditSettingsLoading}
                  style={{ backgroundColor: '#8BC34A', color: '#fff', textTransform: 'none', fontWeight: 600 }}
                >
                  {this.state.creditSettingsLoading ? <CircularProgress size={20} style={{ color: '#fff' }} /> : intl.formatMessage({ id: 'save' })}
                </Button>
              </DialogActions>
            </Dialog>

            {/* Credit Purchase Confirmation */}
            <Dialog
              open={this.state.creditPurchaseConfirmOpen}
              onClose={() => this.setState({ creditPurchaseConfirmOpen: false })}
              maxWidth="xs" fullWidth
            >
              <DialogTitle>{intl.formatMessage({ id: 'subscription.credit.purchase.confirm.title' })}</DialogTitle>
              <DialogContent>
                <Typography variant="body1">
                  {intl.formatMessage({ id: 'subscription.credit.purchase.confirm.message' }, { amount: `R$ ${parseFloat(this.state.creditPurchaseAmount || 0).toFixed(2)}` })}
                </Typography>
              </DialogContent>
              <DialogActions>
                <Button onClick={() => this.setState({ creditPurchaseConfirmOpen: false })} style={{ textTransform: 'none' }}>
                  {intl.formatMessage({ id: 'cancel' })}
                </Button>
                <Button variant="contained" onClick={this.handlePurchaseCredits}
                  disabled={this.state.creditPurchaseLoading}
                  style={{ backgroundColor: '#8BC34A', color: '#fff', textTransform: 'none', fontWeight: 600 }}
                >
                  {this.state.creditPurchaseLoading ? <CircularProgress size={20} style={{ color: '#fff' }} /> : intl.formatMessage({ id: 'subscription.credit.buy' })}
                </Button>
              </DialogActions>
            </Dialog>

            {this.state.loading && (
              <Overlay>
                <CircularProgress color="secondary" />
              </Overlay>
            )}

            <CustomizedSnackbars
              variant={this.state.notificationVariant}
              message={this.state.notificationMessage}
              isOpen={this.state.openNotification}
              toClose={this.closeNotification}
            />
          </Container>
        </main>
        <Footer />
      </div>
    )
  }
}

SubscriptionManagement.propTypes = {
  classes: PropTypes.object.isRequired
}

const mapStateToProps = state => ({
  actionsHeaderMenu: state.actionsHeaderMenu,
  headerMenu: state.headerMenu,
  userSession: state.userSession,
})

const mapDispatchToProps = dispatch => bindActionCreators(componentActions, dispatch)

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(SubscriptionManagement)))
